webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth_js__ = __webpack_require__(621);




var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.request.use(function (config) {
  var token = __WEBPACK_IMPORTED_MODULE_2__services_auth_js__["a" /* default */].getToken();
  var info = JSON.parse(atob(token));

  if (token) {
    config.headers['Token'] = info.token;
  }
  return config;
});

service.interceptors.response.use(function (response) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
}, function (error) {
  var res = error.response;
  if (res.status === 403 || res.status === 401) {
    __WEBPACK_IMPORTED_MODULE_2__services_auth_js__["a" /* default */].deleteToken();
    window.location.href = '/';
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(573);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDropdown_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cdf5fb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDropdown_vue__ = __webpack_require__(603);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cdf5fb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterMaterialList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/create',
    method: 'post',
    data: data
  });
}

function generateCode(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/generate-code',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/update',
    method: 'put',
    data: data
  });
}

function getMasterMaterialList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material/common-list',
    method: 'get'
  });
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterUomList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/update',
    method: 'put',
    data: data
  });
}

function getMasterUomList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/common-list',
    method: 'get'
  });
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = history;
/* harmony export (immutable) */ __webpack_exports__["e"] = store;
/* harmony export (immutable) */ __webpack_exports__["a"] = best_sale;
/* harmony export (immutable) */ __webpack_exports__["b"] = config;
/* harmony export (immutable) */ __webpack_exports__["d"] = order_processing_time;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function history(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/history',
    method: 'get',
    params: data
  });
}

function store() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/store',
    method: 'get'
  });
}

function best_sale(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/best_sale',
    method: 'get',
    params: data
  });
}

function config() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/system/config',
    method: 'get'
  });
}

function order_processing_time(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/order-processing-time',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterGroupList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/update',
    method: 'put',
    data: data
  });
}

function getMasterGroupList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-group/common-list',
    method: 'get'
  });
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterAccountList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/update',
    method: 'put',
    data: data
  });
}

function getMasterAccountList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-account/common-list',
    method: 'get'
  });
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterSupplierList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/update',
    method: 'put',
    data: data
  });
}

function getMasterSupplierList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-supplier/common-list',
    method: 'get'
  });
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareLoader_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_74b84ce5_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareLoader_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_74b84ce5_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* unused harmony export getRole */
/* harmony export (immutable) */ __webpack_exports__["e"] = getRolePermission;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/detail',
    method: 'get',
    params: data
  });
}

function getRole() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/list',
    method: 'get'
  });
}

function getRolePermission() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/roles_permissions',
    method: 'get'
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/role/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPermissionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/permission/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/permission/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/permission/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/permission/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/permission/update',
    method: 'put',
    data: data
  });
}

function getPermissionList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/common/permission/list',
    method: 'get'
  });
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterTypeList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/update',
    method: 'put',
    data: data
  });
}

function getMasterTypeList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-type/common-list',
    method: 'get'
  });
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterGenstoreList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/update',
    method: 'put',
    data: data
  });
}

function getMasterGenstoreList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-genstore/common-list',
    method: 'get'
  });
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterMaterialDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/create',
    method: 'post',
    data: data
  });
}

function generateCode(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/generate-code',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterMaterialDetail() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail/common-list',
    method: 'get'
  });
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterUomList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterUomDetailList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function getMasterUomList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom/common-list',
    method: 'get'
  });
}

function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterUomDetailList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-uom-detail/common-list',
    method: 'get'
  });
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterRecipeList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function getMasterRecipeList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/common-list',
    method: 'get'
  });
}

function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_js__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notification__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_numeral_filter__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);


















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default.a, {
  autoFinish: false
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_moment___default.a, {
  moment: __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default.a
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].router = router;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(802), {
  auth: {
    request: function request(req, token) {
      var info = JSON.parse(atob(token));
      this.options.http._setHeaders.call(this, req, { Token: info.token });
    },
    response: function response(res) {
      if (res.data.data == null || res.data.data.length == 0 || res.data.data.key == null) {
        return null;
      }
      var token = res.data.data.token;
      var key = res.data.data.key;
      var info = {
        token: token.trim(),
        key: JSON.parse(atob(key.trim()))
      };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Market'] = info.key.client_id;
      return btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
    }
  },
  http: __webpack_require__(806),
  router: __webpack_require__(807),
  loginData: {
    url: "https://api-phr.ch.diqit.io/v1/user" + '/ch_login',
    method: 'POST',
    redirect: '/',
    fetchUser: false
  },
  logoutData: {
    url: "https://api-phr.ch.diqit.io/v1/user" + '/ch_logout',
    method: 'POST'
  },
  refreshData: {
    enabled: false
  },
  fetchData: {
    enabled: false,
    success: function success(res) {
      var info = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].auth.token();
      info = JSON.parse(atob(info));
      info.key.group = info.key.roles;
      info.key.roles = info.key.permissions;
      info.key.store_code = info.key.info.outlets.length > 0 ? info.key.info.outlets[0] : '';
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Market'] = info.key.info.client_id;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].auth.user(info.key);
    }
  },
  notFoundRedirect: {
    path: '/pages/404'
  },
  forbiddenRedirect: {
    path: '/pages/404'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('json', function (value) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_notification___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_numeral_filter__["a" /* default */]);

var main = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  i18n: __WEBPACK_IMPORTED_MODULE_8__lang_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});
window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];
main.$i18n.locale = main.$session.get('lang') || 'en';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Lang'] = main.$session.get('lang') || 'en';

/* harmony default export */ __webpack_exports__["default"] = (main);

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(570);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__components___["d" /* Sidebar */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_0__components___["b" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: [{
        role: 'report',
        title: true,
        name: 'report',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      }, {
        name: 'sales_history',
        url: '/sales-history',
        icon: 'icon-speedometer'
      }, {
        name: 'product_mix',
        url: '/product-mix',
        icon: 'icon-speedometer'
      }, {
        name: 'order_processing_time',
        url: '/order-processing-time',
        icon: 'icon-speedometer'
      }, {
        name: 'report',
        url: '/report',
        icon: 'fa fa-bar-chart'
      }, {
        title: true,
        name: 'system',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'user',
        url: '/user',
        icon: 'fa fa-user-o'
      }, {
        name: 'role',
        url: '/role',
        icon: 'fa fa-users'
      }, {
        name: 'permission',
        url: '/permission',
        icon: 'fa fa-balance-scale'
      }, {
        name: 'client',
        url: '/client',
        icon: 'fa fa-globe'
      }, {
        title: true,
        name: 'inventory',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'master_data',
        url: '/inventory',
        icon: 'fa fa-tasks',
        children: [{
          name: 'group',
          url: '/inventory/master-group',
          icon: 'icon-puzzle'
        }, {
          name: 'type',
          url: '/inventory/master-type',
          icon: 'fa fa-tag'
        }, {
          name: 'account',
          url: '/inventory/master-account',
          icon: 'fa fa-user'
        }, {
          name: 'supplier',
          url: '/inventory/master-supplier',
          icon: 'fa fa-user-secret'
        }, {
          name: 'genstore',
          url: '/inventory/master-genstore',
          icon: 'fa fa-tag'
        }, {
          name: 'uom',
          url: '/inventory/master-uom',
          icon: 'fa fa-tag'
        }, {
          name: 'uom_detail',
          url: '/inventory/master-uom-detail',
          icon: 'fa fa-tag'
        }, {
          name: 'material',
          url: '/inventory/master-material',
          icon: 'fa fa-user-secret'
        }, {
          name: 'material_detail',
          url: '/inventory/master-material-detail',
          icon: 'fa fa-user-secret'
        }, {
          name: 'material_detail_supplier',
          url: '/inventory/master-material-detail-supplier',
          icon: 'fa fa-user-secret'
        }, {
          name: 'master_material_recipe_mapping',
          url: '/inventory/master-material-recipe-mapping',
          icon: 'fa fa-user-secret'
        }, {
          name: 'recipe',
          url: '/inventory/master-recipe',
          icon: 'fa fa-user-secret'
        }]
      }, {
        name: 'sync_data',
        url: '/inventory',
        icon: 'fa fa-tasks',
        children: [{
          name: 'sync_master',
          url: '/inventory/sync-master',
          icon: 'icon-puzzle'
        }, {
          name: 'sync_master_detail',
          url: '/inventory/sync-master-detail',
          icon: 'fa fa-tag'
        }]
      }]
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  },
  created: function created() {
    var main_page = 'master_material';
    if (this.$route.name == 'home') {
      if (this.$auth.user().group) {
        this.$auth.user().group.forEach(function (item) {
          if (item == "phd") {
            main_page = 'master_group';
          }
        });
      } else {
        main_page = 'login';
      }
      this.$router.push({ name: main_page });
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */]
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(572);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return this.$t(item);
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_ChangeLangues_vue__ = __webpack_require__(187);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-header',
  components: {
    HeaderDropdownAccnt: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown-accnt',
  data: function data() {
    return {};
  },
  methods: {
    logout: function logout() {
      this.$Progress.start();
      this.$auth.logout({
        makeRequest: true,
        success: function success(response) {
          this.$Progress.finish();
          console.log(response);
        },
        error: function error(_error) {
          this.$Progress.fail();
          console.log(_error);
        },
        redirect: '/login'
      });
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLangues_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d548a49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLangues_vue__ = __webpack_require__(583);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLangues_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d548a49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLangues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lang',
  data: function data() {
    return {
      current_lang: 'en'
    };
  },
  methods: {
    setLang: function setLang(lang) {
      this.$store.dispatch('setLang', lang);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang = lang;
      __WEBPACK_IMPORTED_MODULE_1_js_cookie__["set"]('locale', lang);
      this.$session.set('lang', lang);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.headers.common['Lang'] = lang;
    }
  },
  created: function created() {
    this.current_lang = this.$session.get('lang') || 'en';
    this.setLang(this.current_lang);
  },

  watch: {
    current_lang: function current_lang(val) {
      this.setLang(val);
    }
  }
});

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMinimizer__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavDivider__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__ = __webpack_require__(598);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_0__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_1__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user__ = __webpack_require__(199);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      model: 'user',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'username',
          search: true,
          sort: true
        }, {
          name: 'email',
          search: true,
          sort: true
        }, {
          name: 'roles',
          search: false,
          sort: false,
          render: function render(data, row) {
            var html = [];
            for (var i in data) {
              html.push(_this.$t(data[i].code));
            }
            return html.join('<br/>');
          }
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this2 = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_user__["a" /* changeStatusItem */])(data).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.refreshData();
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_user__["c" /* fetchAll */])(params).then(function (response) {
        _this3.dataTable.body = response.data.data.items;
        _this3.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    },
    position: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    all: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      value: this.selected,
      values: this.options
    };
  },
  methods: {
    setSelected: function setSelected(val) {
      this.value = val;
      if (this.value == 'all') {
        this.$emit('input', null);
      } else {
        this.$emit('input', this.value);
      }
    }
  },
  created: function created() {
    if (this.all) {
      var newOptions = ['all'];
      for (var i in this.options) {
        newOptions.push(this.options[i]);
      }
      this.values = newOptions;
    }
    if (this.selected == null && this.values.length > 0) {
      this.value = this.values[0];
    }
    if (this.position == null) {
      this.position = 'prepend';
    }
    if (this.value == 'all') {
      this.$emit('input', null);
    } else {
      this.$emit('input', this.value);
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = getListOutlet;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/detail',
    method: 'get',
    params: data
  });
}

function getListOutlet() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/report" + '/store',
    method: 'get'
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/update',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_user__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_role__ = __webpack_require__(95);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'user',
      roles: [],
      permissions: [],
      item: {
        uuid: null,
        avatar: '',
        username: '',
        email: '',
        name: '',
        password: '',
        password_confirmation: '',
        store_code: '',
        active: 0,
        roles: [],
        roleIds: [],
        permissions: [],
        permissionIds: [],
        permissionIdsInRoles: []
      },
      avatarData: 'https://bodiezpro.com/wp-content/uploads/2015/09/medium-default-avatar.png',
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkPermission: function checkPermission(id) {
      if (_.indexOf(this.item.permissionIds, id) >= 0) {
        return true;
      }
      return false;
    },
    checkPermissionInRole: function checkPermissionInRole(id) {
      if (_.indexOf(this.item.permissionIdsInRoles, id) >= 0) {
        return true;
      }
      return false;
    },
    previewImage: function previewImage(event) {
      var _this = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this[input.id] = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.item.avatar = input.files[0];
      }
    },
    updatePermission: function updatePermission(val) {
      var _this2 = this;

      if (!val.target.checked) {
        for (var i in this.item.roles) {
          if (this.item.roles[i].id == val.target.value) {
            (function () {
              var permissionIds = [];
              for (var j in _this2.item.roles[i].permissions) {
                permissionIds.push(_this2.item.roles[i].permissions[j].id);
              }

              var permissions = [];
              _this2.item.permissions.forEach(function (item, k) {
                if (_.indexOf(permissionIds, item.id) < 0) {
                  permissions.push(item);
                }
              });
              _this2.item.permissions = permissions;
              _this2.item.roles.splice(i, 1);
            })();
          }
        }
      } else {
        for (var _i in this.roles) {
          if (this.roles[_i].id == val.target.value) {
            if (_.indexOf(this.item.roleIds, val.target.value) < 0) {
              this.item.roles.push(this.roles[_i]);
            }
            break;
          }
        }
      }
      this.updateUserRolePermission();
    },
    updateRole: function updateRole(val) {
      if (!val.target.checked) {
        for (var i in this.item.permissions) {
          if (this.item.permissions[i].id == val.target.value) {
            this.item.permissions.splice(i, 1);
          }
        }

        for (var _i2 in this.item.permissionIds) {
          if (this.item.permissionIds[_i2] == val.target.value) {
            this.item.permissionIds.splice(_i2, 1);
          }
        }

        var roles = [];
        for (var _i3 in this.item.roles) {
          var role = this.item.roles[_i3];
          var permissions = [];

          for (var j in role.permissions) {
            if (_.indexOf(this.item.permissionIds, role.permissions[j].id) >= 0) {
              permissions.push(role.permissions[j]);
            }
          }

          if (role.permissions.length == permissions.length) {
            roles.push(role);
          } else {
            for (var _i4 in permissions) {
              this.item.permissions.push(permissions[_i4]);
            }
          }
        }

        this.item.roles = roles;
      } else {
        for (var _i5 in this.permissions) {
          if (this.permissions[_i5].id == val.target.value && _.indexOf(this.item.permissionIds, val.target.value) < 0) {
            this.item.permissions.push(this.permissions[_i5]);
            this.item.permissionIds.push(parseInt(val.target.value));
          }
        }

        for (var _i6 in this.roles) {
          var _role = this.roles[_i6];

          var permissionIds = [];
          for (var _j in _role.permissions) {
            if (_.indexOf(this.item.permissionIds, _role.permissions[_j].id) >= 0) {
              permissionIds.push(_role.permissions[_j].id);
            }
          }

          if (_role.permissions.length == permissionIds.length && _.indexOf(this.item.roleIds, _role.id) < 0) {
            this.item.roles.push(_role);
          }
        }
      }

      this.updateUserRolePermission();
    },
    updateUserRolePermission: function updateUserRolePermission() {
      var permissionIds = [];
      var permissions = [];
      for (var i in this.item.permissions) {
        if (_.indexOf(permissionIds, this.item.permissions[i].id) < 0) {
          permissionIds.push(this.item.permissions[i].id);
          permissions.push(this.item.permissions[i]);
        }
      }

      var roleIds = [];
      var permissionIdsInRoles = [];
      for (var _i7 in this.item.roles) {
        if (_.indexOf(roleIds, this.item.roles[_i7].id) < 0) {
          roleIds.push(this.item.roles[_i7].id);
          for (var j in this.item.roles[_i7].permissions) {
            if (_.indexOf(permissionIds, this.item.roles[_i7].permissions[j].id) < 0) {
              permissionIds.push(this.item.roles[_i7].permissions[j].id);
              permissions.push(this.item.roles[_i7].permissions[j]);
            }
            if (_.indexOf(permissionIdsInRoles, this.item.roles[_i7].permissions[j].id) < 0) {
              permissionIdsInRoles.push(this.item.roles[_i7].permissions[j].id);
            }
          }
        }
      }

      this.item = {
        uuid: this.item.uuid,
        avatar: this.item.avatar,
        username: this.item.username,
        email: this.item.email,
        name: this.item.name,
        password: this.item.password,
        password_confirmation: this.item.password_confirmation,
        active: this.item.active,
        roles: this.item.roles,
        roleIds: roleIds,
        permissions: permissions,
        permissionIds: permissionIds,
        permissionIdsInRoles: permissionIdsInRoles
      };

      return this.item;
    },
    getDetails: function getDetails() {
      var _this3 = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["d" /* get */])(data).then(function (response) {
        _this3.item = response.data.data;
        _this3.avatarData = _this3.item.avatar;
        _this3.updateUserRolePermission();
        _this3.item.store_code = response.data.data.user_outlets[0] != null ? response.data.data.user_outlets[0].outlet_code : '';
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getRolePermissions: function getRolePermissions(cb) {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_role__["e" /* getRolePermission */])().then(function (response) {
        _this4.roles = response.data.data.roles;
        _this4.permissions = response.data.data.permissions;
        cb();
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this5 = this;

      this.$Progress.start();
      var formData = new FormData();

      for (var i in this.item.permissionIds) {
        if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
          formData.append('permissionIds[]', this.item.permissionIds[i]);
        }
      }
      for (var _i8 in this.item.roleIds) {
        formData.append('roleIds[]', this.item.roleIds[_i8]);
      }

      for (var _i9 in this.item) {
        if (_i9 != 'permissionIds' && _i9 != 'roleIds' && _i9 != 'permissions' && _i9 != 'roles' && _i9 != 'permissionIdsInRoles') {
          if (this.item[_i9] == null) {
            this.item[_i9] = '';
          }
          formData.append(_i9, this.item[_i9]);
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["f" /* update */])(formData).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this6 = this;

      this.$Progress.start();
      var formData = new FormData();

      for (var i in this.item.permissionIds) {
        if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
          formData.append('permissionIds[]', this.item.permissionIds[i]);
        }
      }
      for (var _i10 in this.item.roleIds) {
        formData.append('roleIds[]', this.item.roleIds[_i10]);
      }

      for (var _i11 in this.item) {
        if (_i11 != 'permissionIds' && _i11 != 'roleIds' && _i11 != 'permissions' && _i11 != 'roles' && _i11 != 'permissionIdsInRoles') {
          formData.append(_i11, this.item[_i11]);
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["b" /* create */])(formData).then(function (response) {
        _this6.$notify({
          title: _this6.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this6.$router.push({ name: _this6.model });
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    getListOutlets: function getListOutlets() {
      var _this7 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["e" /* getListOutlet */])().then(function (response) {
        _this7.outlets = {};
        var langs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this7.$i18n.messages);
        for (var l in langs) {
          _this7.outlets[langs[l]] = [];
          for (var i in response.data.data) {
            _this7.outlets[langs[l]].push({
              text: response.data.data[i].name,
              value: response.data.data[i].store_code
            });
          }
        }
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    }
  },
  created: function created() {
    var _this8 = this;

    var langs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages);
    this.outlets = {};
    for (var l in langs) {
      this.outlets[langs[l]] = [];
    }
    this.getListOutlets();
    this.getRolePermissions(function () {
      if (_this8.uuid != null) {
        _this8.getDetails();
      } else {
        _this8.item.uuid = '';
      }
    });
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_role__ = __webpack_require__(95);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RoleList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'role',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_role__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_role__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_role__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_permission__ = __webpack_require__(96);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RoleForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'role',
      permissionsData: [],
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        active: 0,
        permissionIds: []
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkPermission: function checkPermission(id) {
      if (_.indexOf(this.item.permissionIds, id) >= 0) {
        return true;
      }
      return false;
    },
    getDetails: function getDetails() {
      var _this = this;

      var self = this;
      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["d" /* get */])(data).then(function (response) {
        _this.$Progress.finish();
        _this.item.uuid = response.data.data.uuid;
        _this.item.name = response.data.data.name;
        _this.item.description = response.data.data.description;
        _this.item.code = response.data.data.code;
        _this.item.active = response.data.data.active;
        response.data.data.permissions.forEach(function (item) {
          self.item.permissionIds.push(item.id);
        });
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getPermission: function getPermission() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_permission__["e" /* getPermissionList */])().then(function (response) {
        _this2.$Progress.finish();
        _this2.permissionsData = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    checkAll: function checkAll(val) {
      this.item.permissionIds = [];
      if (val.target.checked) {
        for (var i in this.permissionsData) {
          this.item.permissionIds.push(this.permissionsData[i].id);
        }
      }
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["f" /* update */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["b" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getDetails();
    this.getPermission();
  },
  watch: {
    'item.name': function itemName() {
      this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.');
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_permission__ = __webpack_require__(96);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'permission',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_permission__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_permission__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_permission__ = __webpack_require__(96);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'permission',
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        active: 0
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetails: function getDetails() {
      var _this = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["d" /* get */])(data).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["f" /* update */])(this.item).then(function (response) {
        _this2.$Progress.finish();
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$Progress.fail();
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.uuid != null) {
      this.getDetails();
    } else {
      this.item.uuid = '';
    }
  },
  watch: {
    'item.name': function itemName() {
      if (this.item.uuid == '') {
        this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.');
      }
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(210);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'client',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["b" /* fetchAll */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["c"] = get;
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/client/list',
    method: 'get',
    params: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/client/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/client/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/user" + '/client/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_text_mask__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_text_mask__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_3_vue_text_mask___default.a,
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'client',
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        configs: [],
        customizes: []
      },
      configStatus: 0,
      customizeStatus: 0,
      groups: [{ text: 'Customer', value: 'customer' }, { text: 'Product', value: 'product' }, { text: 'Store', value: 'store' }],
      tags: [{ text: 'Text Box', value: 'text_box' }, { text: 'Check Box', value: 'check_box' }, { text: 'Radio Group', value: 'radio_group' }, { text: 'Select', value: 'select' }, { text: 'Switch', value: 'switch' }, { text: 'Text Area', value: 'text_area' }, { text: 'Date Box', value: 'date_box' }],
      types: [{ text: 'Text', value: 'text' }, { text: 'Number', value: 'number' }],
      option: {
        text: '',
        check_value: '',
        uncheck_value: ''
      },
      attributes: {
        text_box: {
          type: 'text',
          class: '',
          default: '',
          place_holder: ''
        },
        check_box: {
          class: '',
          options: [],
          default: ''
        },
        radio_group: {
          class: '',
          options: [],
          default: ''
        },
        select: {
          class: '',
          multiple: false,
          options: [],
          default: ''
        },
        switch: {
          class: '',
          check_value: '',
          uncheck_value: '',
          default: ''
        },
        text_area: {
          class: '',
          rows: 5,
          uncheck_value: '',
          default: '',
          place_holder: ''
        },
        date_box: {
          class: '',
          default: this.$moment().format('DD/MM/YYYY')
        }
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    updateTag: function updateTag(group, field) {
      var _this = this;

      var tag = this.item.customizes[group].fields[field].tag;
      var c = setInterval(function () {
        if (tag != _this.item.customizes[group].fields[field].tag) {
          _this.item.customizes[group].fields[field].attribute = _this._.cloneDeep(_this.attributes[_this.item.customizes[group].fields[field].tag]);
          clearInterval(c);
        }
      }, 100);
    },
    removeOption: function removeOption(group, field, option) {
      var options = [];
      for (var i in this.item.customizes[group].fields[field].attribute.options) {
        if (i != option) {
          options.push(this.item.customizes[group].fields[field].attribute.options[i]);
        }
      }
      this.item.customizes[group].fields[field].attribute.options = options;
    },
    addOption: function addOption(group, field) {
      console.log(this.item.customizes[group].fields[field].attribute);
      this.item.customizes[group].fields[field].attribute.options.push({
        text: '',
        value: ''
      });
    },
    removeField: function removeField(group, field) {
      var fields = [];
      for (var i in this.item.customizes[group].fields) {
        if (i != field) {
          fields.push(this.item.customizes[group].fields[i]);
        }
      }
      this.item.customizes[group].fields = fields;
    },
    addField: function addField(group) {
      this.item.customizes[group].fields.push({
        tag: 'text_box',
        name: '',
        attribute: this._.cloneDeep(this.attributes.text_box)
      });
    },
    removeGroup: function removeGroup(index) {
      var customizes = [];
      for (var i in this.item.customizes) {
        if (i != index) {
          customizes.push(this.item.customizes[i]);
        }
      }
      this.item.customizes = customizes;
    },
    addGroup: function addGroup() {
      this.item.customizes.push({
        group: '',
        fields: []
      });
    },
    removeConfig: function removeConfig(index) {
      var configs = [];
      for (var i in this.item.configs) {
        if (i != index) {
          configs.push(this.item.configs[i]);
        }
      }
      this.item.configs = configs;
    },
    addConfig: function addConfig() {
      this.item.configs.push({
        group: '',
        key: '',
        value: ''
      });
    },
    updateConfigStatus: function updateConfigStatus() {
      if (this.configStatus == 0) {
        this.configStatus = 1;
      } else {
        this.configStatus = 0;
      }
    },
    updateCustomizeStatus: function updateCustomizeStatus() {
      if (this.customizeStatus == 0) {
        this.customizeStatus = 1;
      } else {
        this.customizeStatus = 0;
      }
    },
    getDetails: function getDetails() {
      var _this2 = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["c" /* get */])(data).then(function (response) {
        response.data.data.customizes = [];
        _this2.item = response.data.data;
        var customizes = [];
        _this2.item.customizes = [];

        for (var i in response.data.data.customize_fields) {
          var customize = response.data.data.customize_fields[i];
          if (customizes[customize.group] == null) {
            customizes[customize.group] = {
              group: customize.group,
              fields: []
            };
          }
          customizes[customize.group].fields.push({
            tag: customize.tag,
            name: customize.name,
            attribute: customize.attribute
          });
        }

        for (var _i in customizes) {
          _this2.item.customizes.push(customizes[_i]);
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["d" /* update */])(this.item).then(function (response) {
        _this3.$Progress.finish();
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.uuid != null) {
      this.getDetails();
    } else {
      this.item.uuid = '';
    }
  },
  watch: {}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_group__ = __webpack_require__(63);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGroupList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_group',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_group__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_group__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_group__ = __webpack_require__(63);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGroupForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_group',
      item: {
        id: null,
        code: '',
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_type__ = __webpack_require__(97);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterTypeList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_type',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_type__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_type__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_type__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_group__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_account__ = __webpack_require__(64);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterTypeForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_type',
      item: {
        id: null,
        group_id: '',
        account_id: '',
        code: '',
        name: '',
        description: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      groups: [],
      accounts: []
    };
  },
  methods: {
    getListGroup: function getListGroup() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_group__["e" /* getMasterGroupList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.groups.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListAccount: function getListAccount() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_account__["e" /* getMasterAccountList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.accounts.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.account_id = this.item.account_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["f" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.account_id = this.item.account_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListGroup();
    this.getListAccount();
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_account__ = __webpack_require__(64);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterAccountList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_account',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_account__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_account__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset(val) {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate(val) {
      this.refreshData();
    },
    'filter.actived': function filterActived(val) {
      this.refreshData();
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_account__ = __webpack_require__(64);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterAccountForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_account',
      item: {
        id: null,
        code: '',
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material__ = __webpack_require__(47);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'group_name',
          search: false,
          sort: false
        }, {
          name: 'type_name',
          search: false,
          sort: false
        }, {
          name: 'account_code',
          search: false,
          sort: false
        }, {
          name: 'genstore_code',
          search: false,
          sort: false
        }, {
          name: 'recipe_rate',
          search: false,
          sort: false
        }, {
          name: 'uom_name',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_group__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_type__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_account__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_master_genstore__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_master_uom__ = __webpack_require__(48);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material',
      item: {
        id: null,
        group_id: '',
        type_id: '',
        account_id: '',
        genstore_id: '',
        code: '',
        name: '',
        recipe_rate: '',
        recipe_rate_uom_id: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      groups: [],
      types: [],
      accounts: [],
      genstores: [],
      uoms: []
    };
  },
  methods: {
    getListUom: function getListUom() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_8__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListGroup: function getListGroup() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_group__["e" /* getMasterGroupList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.groups.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getListType: function getListType() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_type__["e" /* getMasterTypeList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.types.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListAccount: function getListAccount() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_account__["e" /* getMasterAccountList */])().then(function (response) {
        for (var i in response.data.data) {
          _this4.accounts.push({
            label: response.data.data[i].code,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getListGenstore: function getListGenstore() {
      var _this5 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_7__api_master_genstore__["e" /* getMasterGenstoreList */])().then(function (response) {
        for (var i in response.data.data) {
          _this5.genstores.push({
            label: response.data.data[i].code,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this6 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["e" /* get */])(params).then(function (response) {
        _this6.item = response.data.data;
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this7 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.type_id = this.item.type_id.value;
      param.account_id = this.item.account_id.value;
      param.genstore_id = this.item.genstore_id.value;
      param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["g" /* update */])(param).then(function (response) {
        _this7.$notify({
          title: _this7.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this7.$router.push({ name: _this7.model });
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this8 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.type_id = this.item.type_id.value;
      param.account_id = this.item.account_id.value;
      param.genstore_id = this.item.genstore_id.value;
      param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["b" /* create */])(param).then(function (response) {
        _this8.$notify({
          title: _this8.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this8.$router.push({ name: _this8.model });
      }).catch(function (error) {
        _this8.$notify({
          title: _this8.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this8.$Progress.finish();
      });
    },
    generateMaterialCode: function generateMaterialCode() {
      var _this9 = this;

      if (this.item.group_id.value && this.item.type_id.value) {
        var params = {
          group_id: this.item.group_id.value,
          group_code: this.getGroupCode(),
          type_id: this.item.type_id.value,
          type_code: this.getTypeCode()
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["d" /* generateCode */])(params).then(function (response) {
          _this9.item.code = response.data.data.material_code;
        }).catch(function (error) {});
      }
    },
    getGroupCode: function getGroupCode() {
      for (var i in this.groups) {
        var group = this.groups[i];
        if (group.value == this.item.group_id.value) {
          return group.code;
        }
      }
    },
    getTypeCode: function getTypeCode() {
      for (var i in this.types) {
        var type = this.types[i];
        if (type.value == this.item.type_id.value) {
          return type.code;
        }
      }
    }
  },
  created: function created() {
    this.getListGroup();
    this.getListType();
    this.getListAccount();
    this.getListGenstore();
    this.getListUom();
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {
    'item.group_id': function itemGroup_id() {
      if (this.id == null) {
        this.generateMaterialCode();
      }
    },
    'item.type_id': function itemType_id() {
      if (this.id == null) {
        this.generateMaterialCode();
      }
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__ = __webpack_require__(99);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'material_name',
          search: false,
          sort: false
        }, {
          name: 'supplier_unit_name',
          search: false,
          sort: false
        }, {
          name: 'smaller_uom_name',
          search: false,
          sort: false
        }, {
          name: 'smaller_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'outlet_uom_name',
          search: false,
          sort: false
        }, {
          name: 'outlet_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'recipe_uom_name',
          search: false,
          sort: false
        }, {
          name: 'recipe_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'report_uom_name',
          search: false,
          sort: false
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_material__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_supplier__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_uom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_master_uom_detail__ = __webpack_require__(100);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_detail',
      edit: 0,
      item: {
        id: null,
        material_id: '',
        supplier_id: '',
        supplier_uom_id: '',
        outlet_uom_id: '',
        outlet_uom_detail_id: '',
        recipe_uom_id: '',
        recipe_uom_detail_id: '',
        smaller_uom_id: '',
        smaller_uom_detail_id: '',
        report_uom_id: '',
        code: '',
        name: '',
        fixed_unit_id: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: [],
      suppliers: [],
      uoms: [],
      uom_details: [],
      smaller_uom_details: [],
      outlet_uom_details: [],
      recipe_uom_details: []
    };
  },
  methods: {
    getListSmallerUomDetail: function getListSmallerUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.smaller_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.smaller_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListOutletUomDetail: function getListOutletUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.outlet_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.outlet_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListRecipeUomDetail: function getListRecipeUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.recipe_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.recipe_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListMaterial: function getListMaterial() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.materials.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListSupplier: function getListSupplier() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_supplier__["e" /* getMasterSupplierList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.suppliers.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getListUom: function getListUom() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListUomDetail: function getListUomDetail() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_7__api_master_uom_detail__["e" /* getMasterUomDetailList */])().then(function (response) {
        for (var i in response.data.data) {
          _this4.uom_details.push(response.data.data[i]);
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this5 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["e" /* get */])(params).then(function (response) {
        _this5.item = response.data.data;
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this6 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.material_id = this.item.material_id.value;
      param.supplier_uom_id = this.item.supplier_uom_id.value;
      param.smaller_uom_id = this.item.smaller_uom_id.value;
      param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value;
      param.outlet_uom_id = this.item.outlet_uom_id.value;
      param.outlet_uom_detail_id = this.item.outlet_uom_detail_id.value;
      param.recipe_uom_id = this.item.recipe_uom_id.value;
      param.recipe_uom_detail_id = this.item.recipe_uom_detail_id.value;
      param.report_uom_id = this.item.report_uom_id.value;
      param.fixed_unit_id = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : '';
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["g" /* update */])(param).then(function (response) {
        _this6.$notify({
          title: _this6.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this6.$router.push({ name: _this6.model });
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this7 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.material_id = this.item.material_id.value;
      param.supplier_uom_id = this.item.supplier_uom_id.value;
      param.smaller_uom_id = this.item.smaller_uom_id.value;
      param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value;
      param.outlet_uom_id = this.item.outlet_uom_id.value;
      param.outlet_uom_detail_id = this.item.outlet_uom_detail_id.value;
      param.recipe_uom_id = this.item.recipe_uom_id.value;
      param.recipe_uom_detail_id = this.item.recipe_uom_detail_id.value;
      param.report_uom_id = this.item.report_uom_id.value;
      param.fixed_unit_id = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : '';

      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["b" /* create */])(param).then(function (response) {
        _this7.$notify({
          title: _this7.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this7.$router.push({ name: _this7.model });
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    generateMaterialDetailCode: function generateMaterialDetailCode() {
      var _this8 = this;

      if (this.item.material_id) {
        var params = {
          material_id: this.item.material_id.value,
          material_code: this.getMaterialCode()
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["d" /* generateCode */])(params).then(function (response) {
          _this8.item.code = response.data.data.code;
        }).catch(function (error) {});
      }
    },
    getMaterialCode: function getMaterialCode() {
      for (var i in this.materials) {
        var material = this.materials[i];
        if (material.value == this.item.material_id.value) {
          return material.code;
        }
      }
    }
  },
  created: function created() {
    this.getListMaterial();
    this.getListSupplier();
    this.getListUom();
    this.getListUomDetail();
    if (this.id != null) {
      this.edit = 1;
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {
    'item.material_id': function itemMaterial_id() {
      if (this.edit == 0) {
        this.generateMaterialDetailCode();
      }
    },
    'item.supplier_uom_id': function itemSupplier_uom_id() {
      if (this.edit == 0) {
        this.item.smaller_uom_detail_id = '';
      }
      if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
        this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value);
      }
    },
    'item.smaller_uom_id': function itemSmaller_uom_id() {
      if (this.edit == 0) {
        this.item.smaller_uom_detail_id = '';
        this.item.outlet_uom_detail_id = '';
      }
      if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
        this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value);
      }
      if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
        this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value);
      }
    },
    'item.outlet_uom_id': function itemOutlet_uom_id() {
      if (this.edit == 0) {
        this.item.outlet_uom_detail_id = '';
        this.item.recipe_uom_detail_id = '';
      }
      if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
        this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value);
      }
      if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
        this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value);
      }
    },
    'item.recipe_uom_id': function itemRecipe_uom_id() {
      if (this.edit == 0) {
        this.item.recipe_uom_detail_id = '';
      } else {
        this.edit = 0;
      }
      if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
        this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value);
      }
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_supplier__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterSupplierList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_supplier',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'address',
          search: true,
          sort: true
        }, {
          name: 'phone',
          search: true,
          sort: true
        }, {
          name: 'fax',
          search: true,
          sort: true
        }, {
          name: 'terms_of_payment',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active, is_import_do) {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: id
      };
      if (is_active === "") {
        data.is_import_do = is_import_do;
      } else {
        data.is_active = is_active;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_supplier__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_supplier__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_supplier__ = __webpack_require__(65);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterSupplierForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_supplier',
      item: {
        id: null,
        code: '',
        name: '',
        address: '',
        phone: '',
        fax: '',
        terms_of_payment: '',
        is_active: 1,
        is_import_do: 1,
        is_tax: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: []
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_uom__ = __webpack_require__(48);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_uom',
      item: {
        id: null,
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetails: function getDetails() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_uom__ = __webpack_require__(48);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_uom',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__ = __webpack_require__(100);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomDetailForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_uom_detail',
      item: {
        id: '',
        from_uom_id: '',
        to_uom_id: '',
        from_uom_qty: '',
        to_uom_qty: '',
        conversion_rate: '',
        name: '',
        is_active: 1
      },
      uoms: [],
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getListUoms: function getListUoms() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["f" /* getMasterUomList */])().then(function (response) {
        _this.uoms = [];
        for (var i in response.data.data) {
          _this.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["d" /* get */])(params).then(function (response) {
        _this2.item = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.from_uom_id = this.item.from_uom_id.value;
      param.to_uom_id = this.item.to_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["g" /* update */])(param).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.from_uom_id = this.item.from_uom_id.value;
      param.to_uom_id = this.item.to_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["b" /* create */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListUoms();
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__ = __webpack_require__(100);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_uom_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'from_uom_name',
          search: false,
          sort: true
        }, {
          name: 'from_uom_qty',
          search: true,
          sort: true
        }, {
          name: 'to_uom_name',
          search: false,
          sort: true
        }, {
          name: 'to_uom_qty',
          search: true,
          sort: true
        }, {
          name: 'conversion_rate',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_genstore__ = __webpack_require__(98);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGenstoreForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_genstore',
      item: {
        id: null,
        code: '',
        name: '',
        description: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["d" /* get */])(data).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_genstore__ = __webpack_require__(98);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGenstoreList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_genstore',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'id',
          search: false,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_genstore__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_genstore__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_recipe__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_material__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_recipe_detail__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_uom__ = __webpack_require__(48);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MasterRecipeForm",
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: "master_recipe",
      formatted: ["action"],
      item: {
        id: null,
        uom_id: "",
        code: "",
        plucode: "",
        sku: "",
        name: "",
        usage: "",
        expired_in: "",
        price: 0,
        is_active: 1,
        is_daily_batch: 1
      },
      material: {},
      popup: {
        material: "",
        recipe: "",
        recipe_detail_usage: "",
        recipe_detail_status: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      uoms: [],
      materials: [],
      list_materials: [],
      recipes: [],
      recipe_details: [],
      recipe_list: [],
      recipe_details_by_recipe: [],
      columns_table: [{
        key: "recipe_or_material_code",
        label: "Recipe / Material Code"
      }, {
        key: "recipe_or_material_name",
        label: "Recipe / Material Name"
      }, {
        key: "usage_detail",
        label: "Usage Detail"
      }, {
        key: "uom"
      }, {
        key: "status",
        formatter: function formatter(value) {
          return parseInt(value) == 0 ? "Not active" : "Active";
        }
      }, {
        key: "detail_price",
        label: "Price"
      }, {
        key: "action"
      }],
      data_table: [],
      selected: 1,
      isHidden: true,
      index: 0,
      is_edit: false,
      index_edit: ""
    };
  },
  methods: {
    showModal: function showModal() {
      this.$refs["my-modal"].show();
    },
    switchTab: function switchTab(data) {
      if (data) {
        this.selected = true;
      } else {
        this.selected = false;
      }
      this.isHidden = data;
    },
    addNew: function addNew() {
      this.showModal();
      this.clearForm();
    },
    removeRecipeDeTail: function removeRecipeDeTail(index) {
      this.item.price = parseInt(this.item.price) - parseInt(this.data_table[index].detail_price);
      this.data_table.splice(index, 1);
      this.recipe_details.splice(index, 1);
    },
    editRecipeDeTail: function editRecipeDeTail(index, row) {
      var _this = this;

      this.is_edit = true;
      this.index_edit = index;
      this.recipe_details.forEach(function (item, key) {
        if (key === index) {
          if (!item.other_recipe_id) {
            _this.selected = true;
            _this.popup.material = {
              value: item.material_id,
              label: row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          } else {
            _this.selected = false;
            _this.popup.recipe = {
              value: item.other_recipe_id,
              label: row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          }
          _this.popup.recipe_detail_usage = item.usage;
          _this.isHidden = _this.selected;
          return;
        }
      });
      this.showModal();
    },
    clearForm: function clearForm() {
      this.selected = true;
      this.popup.material = "";
      this.popup.recipe_detail_usage = "";
      this.popup.recipe_detail_status = 1;
      this.popup.recipe = "";
    },
    handleAdd: function handleAdd() {
      var _this2 = this;

      if (isNaN(this.popup.recipe_detail_usage)) {
        this.$notify({
          title: this.$t("error"),
          text: "Usage must be numeric!",
          type: "error"
        });
        return;
      }
      if (this.selected) {
        if (!this.popup.material) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose Material",
            type: "error"
          });
          return;
        }
        var data_display = {
          recipe_or_material_code: this.material.code,
          recipe_or_material_name: this.material.name,
          weight: this.material.recipe_rate,
          uom: this.material.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: this.material.price
        };
        var data_save = {
          recipe_id: this.item.id,
          material_id: this.popup.material.value,
          other_recipe_id: "",
          weight: this.material.recipe_rate,
          price: this.material.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          var data_table = this.data_table;
          var recipe_details = this.recipe_details;
          data_table.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              _this2.item.price = parseInt(_this2.item.price) + parseInt(_this2.material.price) - parseInt(item.detail_price);
              Vue.set(_this2.data_table, key, data_display);
              return;
            }
          });
          recipe_details.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              Vue.set(_this2.recipe_details, key, data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(data_display);
          this.recipe_details.push(data_save);
          this.item.price = parseInt(this.item.price) + parseInt(this.material.price);
        }
        this.hideModal();
      } else {
        if (!this.popup.recipe) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose recipe",
            type: "error"
          });
          return;
        }

        var recipe_display = [];
        for (var i in this.recipe_list) {
          if (this.recipe_list[i].id == this.popup.recipe.value) {
            recipe_display = this.recipe_list[i];
          }
        }
        var _data_display = {
          recipe_or_material_code: recipe_display.code,
          recipe_or_material_name: recipe_display.name,
          weight: recipe_display.usage,
          uom: recipe_display.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: recipe_display.price,

          _rowVariant: "success"
        };
        var _data_save = {
          recipe_id: this.item.id,
          material_id: "",
          other_recipe_id: this.popup.recipe.value,
          weight: recipe_display.usage,
          price: recipe_display.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          var _data_table = this.data_table;
          var _recipe_details = this.recipe_details;
          _data_table.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              _this2.item.price = parseInt(_this2.item.price) + parseInt(recipe_display.price) - parseInt(item.detail_price);
              Vue.set(_this2.data_table, key, _data_display);
              return;
            }
          });
          _recipe_details.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              Vue.set(_this2.recipe_details, key, _data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(_data_display);
          this.recipe_details.push(_data_save);
          this.item.price = parseInt(this.item.price) + parseInt(recipe_display.price);
        }
        this.hideModal();
      }
      this.clearForm();
    },
    hideModal: function hideModal() {
      this.$refs["my-modal"].hide();
    },
    getListUom: function getListUom() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListRecipe: function getListRecipe() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
        for (var i in response.data.data) {
          if (parseInt(response.data.data[i].id) !== parseInt(_this4.id)) {
            _this4.recipes.push({
              label: response.data.data[i].code + "-" + response.data.data[i].name,
              value: response.data.data[i].id
            });
            _this4.recipe_list.push(response.data.data[i]);
          }
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getListRecipeDetailDefault: function getListRecipeDetailDefault() {
      var _this5 = this;

      this.$Progress.start();
      var param = {
        recipe_id: parseInt(this.id)
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_recipe_detail__["a" /* getMasterRecipeDetailByRecipe */])(param).then(function (response) {
        for (var i in response.data.data) {
          _this5.recipe_details.push(response.data.data[i]);
          var bg_color = "";
          if (typeof response.data.data[i].other_recipe_id != "undefined" && response.data.data[i].other_recipe_id) {
            bg_color = "success";
          }
          _this5.index = parseInt(i);
          _this5.data_table.push({
            recipe_or_material_code: response.data.data[i].code,
            recipe_or_material_name: response.data.data[i].name,
            weight: response.data.data[i].weight,
            uom: response.data.data[i].uom,
            usage_detail: response.data.data[i].usage,
            status: response.data.data[i].is_active,
            detail_price: response.data.data[i].price,

            _rowVariant: bg_color
          });
        }
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    getMaterial: function getMaterial() {
      for (var i in this.list_materials) {
        if (this.list_materials[i].id == this.popup.material.value) {
          this.material = this.list_materials[i];
        }
      }
    },
    getListMaterials: function getListMaterials() {
      var _this6 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
        for (var i in response.data.data) {
          _this6.materials.push({
            label: response.data.data[i].code + "-" + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
        _this6.list_materials = response.data.data;
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this7 = this;

      this.$Progress.start();
      var params = {
        id: parseInt(this.id)
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["d" /* get */])(params).then(function (response) {
        _this7.item = response.data.data;
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this8 = this;

      this.$Progress.start();
      var recipe = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      recipe.uom_id = this.item.uom_id.value;
      var data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["f" /* update */])(data).then(function (response) {
        _this8.$notify({
          title: _this8.$t("success"),
          text: response.data.message,
          type: "success"
        });
        _this8.$router.push({ name: _this8.model });
      }).catch(function (error) {
        _this8.$notify({
          title: _this8.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this8.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this9 = this;

      this.$Progress.start();
      var recipe = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      if (recipe.uom_id != false) {
        recipe.uom_id = this.item.uom_id.value;
      }
      var data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["b" /* create */])(data).then(function (response) {
        _this9.$notify({
          title: _this9.$t("success"),
          text: response.data.message,
          type: "success"
        });
        _this9.$router.push({ name: _this9.model });
      }).catch(function (error) {
        _this9.$notify({
          title: _this9.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this9.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListUom();
    this.getListRecipe();
    this.getListMaterials();
    if (this.id != null) {
      this.getDetails();
      this.getListRecipeDetailDefault();
    } else {
      this.item.id = "";
    }
  },
  watch: {
    "popup.material": function popupMaterial() {
      this.getMaterial();
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_recipe__ = __webpack_require__(101);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterRecipeList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_recipe',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: false
        }, {
          name: 'name',
          search: true,
          sort: false
        }, {
          name: 'plucode',
          search: true,
          sort: true
        }, {
          name: 'usage',
          search: true,
          sort: true
        }, {
          name: 'uom_name',
          search: false,
          sort: true
        }, {
          name: 'expired_in',
          search: true,
          sort: true
        }, {
          name: 'price',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, value, type) {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: id
      };
      if (type === 'active') {
        data.is_active = value;
      } else {
        data.is_daily_batch = value;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_recipe__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_recipe__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_supplier__ = __webpack_require__(65);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailSupplier',
  props: {
    material_detail_id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_detail_supplier',
      item: {
        new: true,
        material_detail_id: null,
        supplier_ids: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      material_details: [],
      suppliers: []
    };
  },
  methods: {
    getListMaterialDetail: function getListMaterialDetail() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["f" /* getMasterMaterialDetail */])().then(function (response) {
        for (var i in response.data.data) {
          _this.material_details.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListSupplier: function getListSupplier() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_supplier__["e" /* getMasterSupplierList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.suppliers.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        material_detail_id: this.material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = {
        'material_detail_id': this.item.material_detail_id.value,
        'supplier_ids': [],
        'is_active': this.item.is_active
      };
      for (var i in this.item.supplier_ids) {
        param.supplier_ids.push(this.item.supplier_ids[i].value);
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["e" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = {
        'material_detail_id': this.item.material_detail_id.value,
        'is_active': this.item.is_active,
        'supplier_ids': []
      };
      for (var i in this.item.supplier_ids) {
        param.supplier_ids.push(this.item.supplier_ids[i].value);
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListMaterialDetail();
    this.getListSupplier();
    if (this.material_detail_id != null) {
      this.item.new = false;
      this.getDetail();
    } else {
      this.item.material_detail_id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["e"] = update;
/* unused harmony export getMaterialDetailSupplierList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/update',
    method: 'put',
    data: data
  });
}

function getMaterialDetailSupplierList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-detail-supplier/common-list',
    method: 'get'
  });
}

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__ = __webpack_require__(233);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailSupplierList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_detail_supplier',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'material_detail_name',
          search: true,
          sort: true
        }, {
          name: 'supplier_names',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(material_detail_id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        material_detail_id: material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_recipe__ = __webpack_require__(101);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialRecipeMapping',
  props: {
    material_recipe_mapping_id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_recipe_mapping',
      item: {
        new: true,
        id: null,
        source_type: '',
        source_code: '',
        destination_type: '',
        destination_code: '',
        active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: [],
      source_type: [{ label: 'Choose type', value: 0 }, { label: 'Material', value: 1 }, { label: 'Recipe', value: 2 }],
      source_codes: [],
      destination_codes: []
    };
  },
  methods: {
    getListSource: function getListSource(type) {
      var _this = this;

      this.$Progress.start();
      if (type === 1) {
        this.$Progress.start();
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
          for (var i in response.data.data) {
            _this.source_codes.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this.$notify({
            title: _this.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this.$Progress.finish();
        });
      } else if (type === 2) {
        Object(__WEBPACK_IMPORTED_MODULE_4__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
          for (var i in response.data.data) {
            _this.source_codes.push({
              label: response.data.data[i].code + '-' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this.$notify({
            title: _this.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this.$Progress.finish();
        });
      }
    },
    getListDestination: function getListDestination(type) {
      var _this2 = this;

      this.$Progress.start();
      if (type === 1) {
        this.$Progress.start();
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
          for (var i in response.data.data) {
            _this2.destination_codes.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this2.$notify({
            title: _this2.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this2.$Progress.finish();
        });
      } else if (type === 2) {
        Object(__WEBPACK_IMPORTED_MODULE_4__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
          for (var i in response.data.data) {
            _this2.destination_codes.push({
              label: response.data.data[i].code + '-' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this2.$notify({
            title: _this2.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this2.$Progress.finish();
        });
      }
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        material_recipe_mapping_id: this.material_recipe_mapping_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
        _this3.getListSource(_this3.item.source_type.value);
        _this3.getListDestination(_this3.item.destination_type.value);
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = {};
      param.id = this.material_recipe_mapping_id;
      param.source_type = this.item.source_type.value;
      param.source_id = this.item.source_code.value;
      param.source_code = this.item.source_code.code;
      param.destination_type = this.item.destination_type.value;
      param.destination_id = this.item.destination_code.value;
      param.destination_code = this.item.destination_code.code;
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["e" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = {};
      param.source_type = this.item.source_type.value;
      param.source_id = this.item.source_code.value;
      param.source_code = this.item.source_code.code;
      param.destination_type = this.item.destination_type.value;
      param.destination_id = this.item.destination_code.value;
      param.destination_code = this.item.destination_code.code;
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.material_recipe_mapping_id != null) {
      this.item.new = false;
      this.getDetail();
    } else {
      this.item.material_recipe_mapping_id = '';
    }
  },
  watch: {
    'item.source_type': function itemSource_type() {
      this.source_codes = [];
      if (this.item.source_type.value !== 0) {
        this.getListSource(this.item.source_type.value);
      }
    },
    'item.destination_type': function itemDestination_type() {
      this.destination_codes = [];
      if (this.item.destination_type.value !== 0) {
        this.getListDestination(this.item.destination_type.value);
      }
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["e"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-recipe-mapping/list',
    method: 'get',
    params: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-recipe-mapping/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-recipe-mapping/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-material-recipe-mapping/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__ = __webpack_require__(236);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialRecipeMappingList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_recipe_mapping',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'source_type_name',
          search: false,
          sort: false
        }, {
          name: 'source_code',
          search: false,
          sort: false
        }, {
          name: 'destination_type_name',
          search: false,
          sort: false
        }, {
          name: 'destination_code',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(material_detail_id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        material_detail_id: material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__["changeStatusItem"])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }
      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }
    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sync_master__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_table_sync__ = __webpack_require__(701);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'sync_master',
      tableSyncData: [],
      item: {
        id: null,
        version: '',
        tableSyncIds: []
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkAll: function checkAll(val) {
      this.item.tableSyncIds = [];
      if (val.target.checked) {
        for (var i in this.tableSyncData) {
          this.item.tableSyncIds.push(this.tableSyncData[i].id);
        }
      }
    },
    getTableSync: function getTableSync() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_table_sync__["a" /* getTableSyncList */])().then(function (response) {
        _this.$Progress.finish();
        _this.tableSyncData = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["get"])(params).then(function (response) {
        _this2.item = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["update"])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["a" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getTableSync();
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["d"] = syncData;
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/sync-master/list',
    method: 'get',
    params: data
  });
}

function syncData(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/sync-master/sync-data',
    method: 'post',
    data: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/sync-master/create',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sync_master__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_report__ = __webpack_require__(49);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'sync_master',
      field: null,
      key: null,
      popup: {
        storeData: []
      },
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      item: {
        id: null,
        storeIds: []
      },
      dataTable: {
        body: [],
        header: [{
          name: 'version',
          search: true,
          sort: true
        }, {
          name: 'is_sync',
          search: true,
          sort: true,
          render: function render(data) {
            if (data) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    checkAll: function checkAll(val) {
      this.item.storeIds = [];
      if (val.target.checked) {
        for (var i in this.popup.storeData) {
          this.item.storeIds.push(this.popup.storeData[i].store_code);
        }
      }
    },
    confirm: function confirm() {
      this.showMsgToConfirm();
    },
    showMsgToConfirm: function showMsgToConfirm() {
      var _this = this;

      this.$bvModal.msgBoxConfirm('Are you sure for sync to real Store', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(function (value) {
        if (value) {
          _this.$Progress.start();
          var data = {
            id: _this.item.id,
            storeIds: _this.item.storeIds
          };
          Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master__["d" /* syncData */])(data).then(function (response) {
            _this.$notify({
              title: _this.$t('success'),
              text: response.data.message,
              type: 'success'
            });
            _this.refreshData();
          }).catch(function (error) {
            _this.$notify({
              title: _this.$t('error'),
              text: error.data.message,
              type: 'error'
            });
          }).then(function () {
            _this.$Progress.finish();
          });
        }
      }).catch(function (err) {});
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master__["b" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    showStores: function showStores(id) {
      this.item.storeIds = [];
      this.item.id = id;
      this.getStore();
      this.$refs['store-modal'].show();
    },
    getStore: function getStore() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__api_report__["e" /* store */])().then(function (response) {
        _this3.popup.storeData = response.data.data;
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sync_master_detail__ = __webpack_require__(707);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'sync_master_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        is_sync: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'version',
          search: true,
          sort: true
        }, {
          name: 'store_code',
          search: true,
          sort: true
        }, {
          name: 'file_name',
          search: true,
          sort: true
        }, {
          name: 'is_sync',
          search: true,
          sort: true,
          render: function render(data) {
            if (data) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.is_sync != null) {
        params.is_sync = this.filter.is_sync;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master_detail__["a" /* fetchAll */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.is_sync': function filterIs_sync() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_report__ = __webpack_require__(49);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      total_sales: 0,
      total_cheque: 0,
      sos: 0,
      target_sales: 0,
      current: 0,
      target: 100,
      show_target: true,
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#9B59B6', '#73818f', '#4dbd74'],
        data: []
      },
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      sale_by_type_labels: {},
      sale_by_type_datasets: {},
      cheque_by_channel_labels: {},
      cheque_by_channel_datasets: {},
      cheque_by_type_labels: {},
      cheque_by_type_datasets: {}
    };
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__api_report__["c" /* history */])(params).then(function (response) {
        _this.total_cheque = response.data.data.total_cheque;
        _this.target_sales = response.data.data.target;
        _this.total_sales = response.data.data.total_sale;
        _this.sos = response.data.data.sos;
        _this.sale_by_channel_datasets[0].data = [response.data.data.sales.online, response.data.data.sales.call_center, response.data.data.sales.offline, response.data.data.sales.offline_go_jek, response.data.data.sales.grab];
        _this.sale_by_type_datasets[0].data = [response.data.data.sales.takeaway, response.data.data.sales.delivery, response.data.data.sales.eat_in];
        _this.cheque_by_channel_datasets[0].data = [response.data.data.bill.online, response.data.data.bill.call_center, response.data.data.bill.offline, response.data.data.bill.offline_go_jek, response.data.data.bill.grab];
        _this.cheque_by_type_datasets[0].data = [response.data.data.bill.takeaway, response.data.data.bill.delivery, response.data.data.bill.eat_in];

        for (var i in _this.languages) {
          _this.sale_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.sales.online / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.sales.call_center / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.sales.offline / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.sales.offline_go_jek / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.sales.grab / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.sale_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.sales.takeaway / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.sales.delivery / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.sales.eat_in / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.cheque_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.bill.online / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.bill.call_center / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.bill.offline / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.bill.offline_go_jek / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.bill.grab / response.data.data.total_cheque * 100).toFixed(2) + '%'];
          _this.cheque_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.bill.takeaway / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.bill.delivery / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.bill.eat_in / response.data.data.total_cheque * 100).toFixed(2) + '%'];
        }

        _this.updateProcess();
        _this.loading = false;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateProcess: function updateProcess() {
      var _this2 = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this2.show_target = true;
      }, 2000);
    }
  },
  created: function created() {
    var _this3 = this;

    for (var i in this.languages) {
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.sale_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
      this.cheque_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.cheque_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
    }
    var pieSalesChannelData = this._.cloneDeep(this.pie_data);
    var pieSalesTypeData = this._.cloneDeep(this.pie_data);
    var pieBillChannelData = this._.cloneDeep(this.pie_data);
    var pieBillTypeData = this._.cloneDeep(this.pie_data);
    this.sale_by_channel_datasets = [pieSalesChannelData];
    this.sale_by_type_datasets = [pieSalesTypeData];
    this.cheque_by_channel_datasets = [pieBillChannelData];
    this.cheque_by_type_datasets = [pieBillTypeData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_5__api_report__["e" /* store */])().then(function (response) {
      _this3.outlets = {};
      for (var l in _this3.languages) {
        _this3.outlets[_this3.languages[l]] = [];
        _this3.outlets[_this3.languages[l]].push({
          label: _this3.$t('all', _this3.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this3.outlets[_this3.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });
          if (_this3.outlet.value == response.data.data[_i].store_code) {
            _this3.outlet.label = response.data.data[_i].name;
          }
        }
      }

      _this3.updateData();
      _this3.updateProcess();

      setInterval(function () {
        _this3.updateData();
        _this3.updateProcess();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this3.$notify({
        title: _this3.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this3.$Progress.finish();
    });
  },
  watch: {
    outlet: function outlet(val) {
      this.updateData();
      this.updateProcess();
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(103);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          legend: {
            fullWidth: true
          },
          animation: {
            duration: 500,
            easing: 'linear'
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    datasets: function datasets(val) {
      this.render();
    }
  }
});

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(103);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, { responsive: true, maintainAspectRatio: false });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    'datasets.0.data': function datasets0Data(val) {
      this.render();
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'SquareLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '50px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size
      }
    };
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(104);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */]
  },
  data: function data() {
    return {
      startDate: this.$moment().format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(7, 'day').format('YYYY-MM-DD'),
      outlet: null,
      type: 'weekly',
      permissions: {},
      total_sales: 736254122,
      total_cheque: 231233,
      sos: 90.23,
      target_sales: 632562541,
      current: 0,
      target: 100,
      show_target: true,
      bar_data: {
        label: '',
        backgroundColor: '#20a8d8',
        data: []
      },
      bar_line_data: {
        label: '',
        data: [],
        type: 'line',
        pointStyle: 'line',
        backgroundColor: '#f86c6b',
        pointBackgroundColor: '#f86c6b',
        pointBorderColor: '#f86c6b',
        showLine: false,
        fill: false
      },
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#4dbd74', '#63c2de', '#73818f'],
        data: []
      },
      sale_trend_labels: {},
      sale_trend_datasets: {},
      cheque_trend_labels: {},
      cheque_trend_datasets: {},
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    updateDateRange: function updateDateRange(val) {
      this.startDate = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.endDate = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.updateData();
    },
    updateData: function updateData() {
      var from = this.$moment(this.startDate, 'YYYY-MM-DD');
      var to = this.$moment(this.endDate, 'YYYY-MM-DD');
      var diff = from.diff(to, 'days');
      this.total_cheque = (Math.floor(Math.random() * 50 + 1) + 50) * diff;
      this.target_sales = this.total_cheque * (Math.floor(Math.random() * 5 + 1) + 80);
      this.total_sales = this.total_cheque * (Math.floor(Math.random() * 50 + 1) + 70);
      this.sos = Math.floor(Math.random() * 15 + 1) + 85;
      var online = (Math.floor(Math.random() * 10 + 1) + 20) * diff;
      var offline = (Math.floor(Math.random() * 10 + 1) + 15) * diff;
      var callcenter = (Math.floor(Math.random() * 10 + 1) + 10) * diff;
      var aggregator = (Math.floor(Math.random() * 10 + 1) + 5) * diff;
      for (var i in this.languages) {
        this.sale_by_channel_datasets[this.languages[i]][0].data = [online, callcenter, offline, aggregator];
      }
      this.updateProcess();
    },
    updateDataByType: function updateDataByType() {
      if (this.type == 'daily') {
        var saleData = [];
        var saleTarget = [];
        var chequeData = [];
        var chequeTarget = [];
        for (var i = 11; i >= 0; i--) {
          saleData.push(Math.floor(Math.random() * 50 + 1) + 65);
          saleTarget.push(Math.floor(Math.random() * 5 + 1) + 80);
          chequeData.push(Math.floor(Math.random() * 50 + 1) + 65);
          chequeTarget.push(Math.floor(Math.random() * 5 + 1) + 80);
        }

        for (var _i in this.languages) {
          this.sale_trend_datasets[this.languages[_i]][0].data = saleTarget;
          this.sale_trend_datasets[this.languages[_i]][1].data = saleData;
          this.cheque_trend_datasets[this.languages[_i]][0].data = chequeTarget;
          this.cheque_trend_datasets[this.languages[_i]][1].data = chequeData;
        }
      } else if (this.type == 'weekly') {
        var _saleData = [];
        var _saleTarget = [];
        var _chequeData = [];
        var _chequeTarget = [];

        for (var _i2 in this.languages) {
          this.sale_trend_labels[this.languages[_i2]] = [];
          this.cheque_trend_labels[this.languages[_i2]] = [];
        }

        for (var _i3 = 11; _i3 >= 0; _i3--) {
          _saleData.push((Math.floor(Math.random() * 50 + 1) + 50) * 7);
          _saleTarget.push((Math.floor(Math.random() * 5 + 1) + 80) * 7);
          _chequeData.push((Math.floor(Math.random() * 50 + 1) + 50) * 7);
          _chequeTarget.push((Math.floor(Math.random() * 5 + 1) + 80) * 7);
        }

        for (var _i4 in this.languages) {
          this.sale_trend_datasets[this.languages[_i4]][0].data = _saleTarget;
          this.sale_trend_datasets[this.languages[_i4]][1].data = _saleData;
          this.cheque_trend_datasets[this.languages[_i4]][0].data = _chequeTarget;
          this.cheque_trend_datasets[this.languages[_i4]][1].data = _chequeData;
        }
      } else if (this.type == 'monthly') {
        var _saleData2 = [];
        var _saleTarget2 = [];
        var _chequeData2 = [];
        var _chequeTarget2 = [];

        for (var _i5 in this.languages) {
          this.sale_trend_labels[this.languages[_i5]] = [];
          this.cheque_trend_labels[this.languages[_i5]] = [];
        }
        for (var _i6 = 11; _i6 >= 0; _i6--) {
          _saleData2.push((Math.floor(Math.random() * 50 + 1) + 50) * 30);
          _saleTarget2.push((Math.floor(Math.random() * 5 + 1) + 80) * 30);
          _chequeData2.push((Math.floor(Math.random() * 50 + 1) + 50) * 30);
          _chequeTarget2.push((Math.floor(Math.random() * 5 + 1) + 80) * 30);
        }

        for (var _i7 in this.languages) {
          this.sale_trend_datasets[this.languages[_i7]][0].data = _saleTarget2;
          this.sale_trend_datasets[this.languages[_i7]][1].data = _saleData2;
          this.cheque_trend_datasets[this.languages[_i7]][0].data = _chequeTarget2;
          this.cheque_trend_datasets[this.languages[_i7]][1].data = _chequeData2;
        }
      }
    },
    updateProcess: function updateProcess() {
      var _this = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this.show_target = true;
      }, 1000);
    },
    updateLabel: function updateLabel() {
      var dates = [];
      var dbDates = [];
      if (this.type == 'daily') {
        for (var i = 11; i >= 0; i--) {
          var date = this.$moment().subtract(i, 'day');
          dates.push(date.format('DD-MM-YYYY'));
          dbDates.push({
            start: date.format('YYYY-MM-DD') + ' 00:00:00',
            end: date.format('YYYY-MM-DD') + ' 23:59:59'
          });
        }

        for (var _i8 in this.languages) {
          this.sale_trend_labels[this.languages[_i8]] = dates;
          this.cheque_trend_labels[this.languages[_i8]] = dates;
        }
      } else if (this.type == 'weekly') {
        for (var _i9 in this.languages) {
          this.sale_trend_labels[this.languages[_i9]] = [];
          this.cheque_trend_labels[this.languages[_i9]] = [];
        }

        for (var _i10 = 11; _i10 >= 0; _i10--) {
          var _date = this.$moment().subtract(_i10 * 7, 'day');

          for (var _i11 in this.languages) {
            this.sale_trend_labels[this.languages[_i11]].push(this.$t(_date.format('Wo').toLowerCase(), this.languages[_i11]));
            this.cheque_trend_labels[this.languages[_i11]].push(this.$t(_date.format('Wo').toLowerCase(), this.languages[_i11]));
          }

          dbDates.push({
            start: _date.startOf('week').format('YYYY-MM-DD') + ' 00:00:00',
            end: _date.endOf('week').format('YYYY-MM-DD') + ' 23:59:59'
          });
        }
      } else if (this.type == 'monthly') {
        for (var _i12 in this.languages) {
          this.sale_trend_labels[this.languages[_i12]] = [];
          this.cheque_trend_labels[this.languages[_i12]] = [];
        }
        for (var _i13 = 11; _i13 >= 0; _i13--) {
          var _date2 = this.$moment().subtract(_i13, 'month');

          for (var _i14 in this.languages) {
            this.sale_trend_labels[this.languages[_i14]].push(this.$t(_date2.format('MMMM').toLowerCase(), this.languages[_i14]));
            this.cheque_trend_labels[this.languages[_i14]].push(this.$t(_date2.format('MMMM').toLowerCase(), this.languages[_i14]));
          }

          dbDates.push({
            start: _date2.startOf('month').format('YYYY-MM-DD') + ' 00:00:00',
            end: _date2.endOf('month').format('YYYY-MM-DD') + ' 23:59:59'
          });
        }
      }
    }
  },
  created: function created() {
    for (var i in this.languages) {
      this.sale_trend_labels[this.languages[i]] = [];
      this.cheque_trend_labels[this.languages[i]] = [];
      var barLineData = this._.cloneDeep(this.bar_line_data);
      barLineData.label = this.$t('target', this.languages[i]);
      var barData = this._.cloneDeep(this.bar_data);
      barData.label = this.$t('sales_amount', this.languages[i]);
      this.sale_trend_datasets[this.languages[i]] = [barLineData, barData];
      this.cheque_trend_datasets[this.languages[i]] = [barLineData, barData];
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('aggregator', this.languages[i])];
      var pieData = this._.cloneDeep(this.pie_data);
      this.sale_by_channel_datasets[this.languages[i]] = [pieData];
    }
    this.updateDataByType();
    this.updateLabel();
    this.updateData();
    this.permissions = {};
    for (var _i15 in this.$auth.user().permissions) {
      var per = this.$auth.user().permissions[_i15];
      var array = per.split('.');
      var model = array[0];
      var action = [];
      if (this.permissions[model] == null) {
        this.permissions[model] = {
          name: model,
          func: []
        };
      }
      for (var j in array) {
        if (j > 0) {
          action.push(array[j]);
        }
      }
      this.permissions[model].func.push(action.join('_'));
    }
  },
  watch: {
    type: function type(val) {
      this.updateDataByType();
      this.updateLabel();
    },
    outlet: function outlet(val) {
      this.updateData();
      this.updateDataByType();
      this.updateLabel();
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_report__ = __webpack_require__(49);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SalesHistory',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      total_sales: 0,
      total_cheque: 0,
      sos: 0,
      target_sales: 0,
      current: 0,
      target: 100,
      show_target: true,
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#9B59B6', '#73818f', '#4dbd74'],
        data: []
      },
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      sale_by_type_labels: {},
      sale_by_type_datasets: {},
      cheque_by_channel_labels: {},
      cheque_by_channel_datasets: {},
      cheque_by_type_labels: {},
      cheque_by_type_datasets: {}
    };
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date
      };
      Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["c" /* history */])(params).then(function (response) {
        _this.total_cheque = response.data.data.total_cheque;
        _this.target_sales = response.data.data.target;
        _this.total_sales = response.data.data.total_sale;
        _this.sos = response.data.data.sos;
        _this.sale_by_channel_datasets[0].data = [response.data.data.sales.online, response.data.data.sales.call_center, response.data.data.sales.offline, response.data.data.sales.offline_go_jek, response.data.data.sales.grab];
        _this.sale_by_type_datasets[0].data = [response.data.data.sales.takeaway, response.data.data.sales.delivery, response.data.data.sales.eat_in];
        _this.cheque_by_channel_datasets[0].data = [response.data.data.bill.online, response.data.data.bill.call_center, response.data.data.bill.offline, response.data.data.bill.offline_go_jek, response.data.data.bill.grab];
        _this.cheque_by_type_datasets[0].data = [response.data.data.bill.takeaway, response.data.data.bill.delivery, response.data.data.bill.eat_in];

        for (var i in _this.languages) {
          _this.sale_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.sales.online / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.sales.call_center / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.sales.offline / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.sales.offline_go_jek / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.sales.grab / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.sale_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.sales.takeaway / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.sales.delivery / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.sales.eat_in / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.cheque_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.bill.online / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.bill.call_center / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.bill.offline / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.bill.offline_go_jek / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.bill.grab / response.data.data.total_cheque * 100).toFixed(2) + '%'];
          _this.cheque_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.bill.takeaway / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.bill.delivery / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.bill.eat_in / response.data.data.total_cheque * 100).toFixed(2) + '%'];
        }

        _this.updateProcess();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.loading = false;
        _this.$Progress.finish();
      });
    },
    updateProcess: function updateProcess() {
      var _this2 = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this2.show_target = true;
      }, 2000);
    },
    refresh: function refresh() {
      this.updateData();
      this.updateProcess();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this3 = this;

    for (var i in this.languages) {
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.sale_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
      this.cheque_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.cheque_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
    }
    var pieSalesChannelData = this._.cloneDeep(this.pie_data);
    var pieSalesTypeData = this._.cloneDeep(this.pie_data);
    var pieBillChannelData = this._.cloneDeep(this.pie_data);
    var pieBillTypeData = this._.cloneDeep(this.pie_data);
    this.sale_by_channel_datasets = [pieSalesChannelData];
    this.sale_by_type_datasets = [pieSalesTypeData];
    this.cheque_by_channel_datasets = [pieBillChannelData];
    this.cheque_by_type_datasets = [pieBillTypeData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["e" /* store */])().then(function (response) {
      _this3.outlets = {};
      for (var l in _this3.languages) {
        _this3.outlets[_this3.languages[l]] = [];
        _this3.outlets[_this3.languages[l]].push({
          label: _this3.$t('all', _this3.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this3.outlets[_this3.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });

          if (_this3.outlet.value == response.data.data[_i].store_code) {
            _this3.outlet.label = response.data.data[_i].name;
          }
        }
      }

      _this3.refresh();

      setInterval(function () {
        _this3.refresh();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this3.$notify({
        title: _this3.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this3.$Progress.finish();
    });
  },
  watch: {}
});

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Doughnut__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_report__ = __webpack_require__(49);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductMix',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Doughnut: __WEBPACK_IMPORTED_MODULE_2__charts_Doughnut__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SquareLoader_vue__["a" /* default */],
    datePicker: __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default.a
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#4dbd74', '#73818f', '#17A589', '#EB984E', '#9B59B6', '#34495E', '#D98880'],
        data: []
      },
      best_sale_data: [],
      best_sale_labels: [],
      best_sale_datasets: {}
    };
  },
  methods: {
    updateOutlet: function updateOutlet(val) {
      this.outlet = val;
    },
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date,
        top: 10
      };
      Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["a" /* best_sale */])(params).then(function (response) {
        _this.best_sale_labels = [];
        _this.best_sale_datasets[0].data = [];
        _this.best_sale_data = [];
        for (var i in response.data.data) {
          var data = response.data.data[i];
          _this.best_sale_labels.push(data.menu_name);
          _this.best_sale_datasets[0].data.push(data.total);
          _this.best_sale_data.push({
            name: data.menu_name,
            total: data.total,
            color: _this.pie_data.backgroundColor[i]
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.loading = false;
        _this.$Progress.finish();
      });
    },
    refresh: function refresh() {
      this.updateData();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this2 = this;

    var bestSaleData = this._.cloneDeep(this.pie_data);
    this.best_sale_datasets = [bestSaleData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["e" /* store */])().then(function (response) {
      _this2.outlets = {};
      for (var l in _this2.languages) {
        _this2.outlets[_this2.languages[l]] = [];
        _this2.outlets[_this2.languages[l]].push({
          label: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var i in response.data.data) {
          _this2.outlets[_this2.languages[l]].push({
            label: response.data.data[i].name,
            value: response.data.data[i].store_code
          });

          if (_this2.outlet.value == response.data.data[i].store_code) {
            _this2.outlet.label = response.data.data[i].name;
          }
        }
      }

      _this2.refresh();

      setInterval(function () {
        _this2.refresh();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this2.$notify({
        title: _this2.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this2.$Progress.finish();
    });
  },
  watch: {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(103);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          } });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    'datasets.0.data': function datasets0Data(val) {
      this.render();
    }
  }
});

/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_report__ = __webpack_require__(49);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderProcessingTime',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker___default.a,
    SquareLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),

      channel: [],

      filter: {
        channel: null
      },

      dataTable: {
        body: [],
        header: [{
          name: 'order_number',
          search: true,
          sort: true
        }, {
          name: 'channel',
          search: true,
          sort: true
        }, {
          name: 'order_type',
          search: true,
          sort: true
        }, {
          name: 'order_date',
          search: true,
          sort: true
        }, {
          name: 'sent_to_kds',
          search: true,
          sort: true
        }, {
          name: 'cooked',
          search: true,
          sort: true
        }, {
          name: 'delivery_start_time',
          search: true,
          sort: true
        }, {
          name: 'customer_recieved',
          search: true,
          sort: true
        }, {
          name: 'encashment_time',
          search: true,
          sort: true
        }, {
          name: 'sos_achived',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 'Y') {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    refreshData: function refreshData() {
      var _this = this;

      this.loading = true;
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type,
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      Object(__WEBPACK_IMPORTED_MODULE_3__api_report__["d" /* order_processing_time */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
        _this.loading = false;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    refresh: function refresh() {
      this.refreshData();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$Progress.start();

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.axios.request({
      method: 'get',
      url: "https://api-phr.ch.diqit.io/v1/report" + '/store'
    }).then(function (response) {
      _this2.outlets = {};
      for (var l in _this2.languages) {
        _this2.outlets[_this2.languages[l]] = [];
        _this2.outlets[_this2.languages[l]].push({
          label: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this2.outlets[_this2.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });

          if (_this2.outlet.value == response.data.data[_i].store_code) {
            _this2.outlet.label = response.data.data[_i].name;
          }
        }
      }
    }).catch(function (error) {});

    Object(__WEBPACK_IMPORTED_MODULE_3__api_report__["b" /* config */])().then(function (response) {
      _this2.channel = {};
      for (var l in _this2.languages) {
        _this2.channel[_this2.languages[l]] = [];
        _this2.channel[_this2.languages[l]].push({
          text: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var c in response.data.data.channel) {
          _this2.channel[_this2.languages[l]].push({
            text: response.data.data.channel[c],
            value: response.data.data.channel[c]
          });
        }
      }
      _this2.refreshData();

      setInterval(function () {
        _this2.refreshData();
      }, 5 * 60 * 1000);
    }).catch(function (error) {}).then(function () {
      _this2.$Progress.finish();
    });
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_ChangeLangues_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    ChangeLanguage: __WEBPACK_IMPORTED_MODULE_0__components_Partials_ChangeLangues_vue__["a" /* default */]
  },
  data: function data() {
    return {
      body: {
        username: '',
        password: ''
      },
      error: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  validations: {
    body: {
      username: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    login: function login() {
      this.$Progress.start();
      this.$auth.login({
        data: {
          username: this.body.username,
          password: this.body.password
        },
        headers: {
          'Accept': 'application/json'
        },
        success: function success(response) {
          this.$Progress.finish();
          this.error = null;
        },
        error: function error(_error) {
          this.$Progress.fail();
          this.$notify({
            title: this.$t('error'),
            text: _error.response.data.message,
            type: 'error'
          });
          this.error = _error.response.data.message;
        }
      });
    }
  }
});

/***/ }),
/* 384 */,
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  components: {},
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    this.$auth.logout();
  }
});

/***/ }),
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a105622_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(545)
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a105622_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Main__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_user_List__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_role_List__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_admin_permission_List__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_admin_client_List__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_admin_inventory_master_group_List__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_admin_inventory_master_type_List__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_admin_inventory_master_account_List__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_admin_inventory_master_material_List__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_admin_inventory_master_material_detail_List__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_admin_inventory_master_supplier_List__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_admin_inventory_master_uom_List__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_admin_inventory_master_uom_detail_List__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_admin_inventory_master_genstore_List__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_admin_inventory_master_recipe_List__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_admin_inventory_master_material_detail_supplier_List__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_admin_inventory_master_material_recipe_mapping_List__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_admin_inventory_sync_master_List__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_admin_inventory_sync_master_detail_List__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_Dashboard__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Report__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_SalesHistory__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_ProductMix__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_OrderProcessingTime__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_pages_Page500__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_admin_Login__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_admin_Logout__ = __webpack_require__(776);























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_47__views_admin_Login__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_48__views_admin_Logout__["a" /* default */]
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__containers_Main__["a" /* default */],
    meta: {
      label: 'home'
    },
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_40__views_Dashboard__["a" /* default */],
      meta: {
        auth: true,
        label: 'dashboard'
      }
    }, {
      path: 'sales-history',
      name: 'sales_history',
      component: __WEBPACK_IMPORTED_MODULE_42__views_SalesHistory__["a" /* default */],
      meta: {
        auth: true,
        label: 'sales_history'
      }
    }, {
      path: 'product-mix',
      name: 'product_mix',
      component: __WEBPACK_IMPORTED_MODULE_43__views_ProductMix__["a" /* default */],
      meta: {
        auth: true,
        label: 'product_mix'
      }
    }, {
      path: 'order-processing-time',
      name: 'order_processing_time',
      component: __WEBPACK_IMPORTED_MODULE_44__views_OrderProcessingTime__["a" /* default */],
      meta: {
        auth: true,
        label: 'order_processing_time'
      }
    }, {
      path: 'report',
      name: 'report',
      component: __WEBPACK_IMPORTED_MODULE_41__views_Report__["a" /* default */],
      meta: {
        auth: { roles: ['report'] },
        label: 'report'
      }
    }, {
      path: 'user',
      redirect: '/user',
      name: 'user',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'user'
      },
      children: [{
        path: '/',
        name: 'user_list',
        component: __WEBPACK_IMPORTED_MODULE_5__views_admin_user_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'user_edit',
        component: __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'user_create',
        component: __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'role',
      redirect: '/role',
      name: 'role',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'role'
      },
      children: [{
        path: '/',
        name: 'role_list',
        component: __WEBPACK_IMPORTED_MODULE_7__views_admin_role_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'role_edit',
        component: __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'role_create',
        component: __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'permission',
      redirect: '/permission',
      name: 'permission',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'permission'
      },
      children: [{
        path: '/',
        name: 'permission_list',
        component: __WEBPACK_IMPORTED_MODULE_9__views_admin_permission_List__["a" /* default */],
        meta: {
          auth: { roles: ['permission.list'] },
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'permission_edit',
        component: __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__["a" /* default */],
        meta: {
          auth: { roles: ['permission.update', 'permission.detail'] },
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'permission_create',
        component: __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__["a" /* default */],
        meta: {
          auth: { roles: ['permission.create'] },
          label: 'create'
        }
      }]
    }, {
      path: 'client',
      redirect: '/client',
      name: 'client',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'client'
      },
      children: [{
        path: '/',
        name: 'client_list',
        component: __WEBPACK_IMPORTED_MODULE_11__views_admin_client_List__["a" /* default */],
        meta: {
          auth: { roles: ['client.list'] },
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'client_edit',
        component: __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__["a" /* default */],
        meta: {
          auth: { roles: ['client.update', 'client.detail'] },
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'client_create',
        component: __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__["a" /* default */],
        meta: {
          auth: { roles: ['client.create'] },
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-group',
      redirect: '/inventory/master-group',
      name: 'master_group',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_group'
      },
      children: [{
        path: '/',
        name: 'master_group_list',
        component: __WEBPACK_IMPORTED_MODULE_13__views_admin_inventory_master_group_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_group_edit',
        component: __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_group_create',
        component: __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-type',
      redirect: '/inventory/master-type',
      name: 'master_type',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_type'
      },
      children: [{
        path: '/',
        name: 'master_type_list',
        component: __WEBPACK_IMPORTED_MODULE_15__views_admin_inventory_master_type_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_type_edit',
        component: __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_type_create',
        component: __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-uom',
      redirect: '/inventory/master-uom',
      name: 'master_uom',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_uom'
      },
      children: [{
        path: '/',
        name: 'master_uom_list',
        component: __WEBPACK_IMPORTED_MODULE_26__views_admin_inventory_master_uom_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_uom_edit',
        component: __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_uom_create',
        component: __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-uom-detail',
      redirect: '/inventory/master-uom-detail',
      name: 'master_uom_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_uom_detail'
      },
      children: [{
        path: '/',
        name: 'master_uom_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_28__views_admin_inventory_master_uom_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_uom_detail_edit',
        component: __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_uom_detail_create',
        component: __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-account',
      redirect: '/inventory/master-account',
      name: 'master_account',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_account'
      },
      children: [{
        path: '/',
        name: 'master_account_list',
        component: __WEBPACK_IMPORTED_MODULE_17__views_admin_inventory_master_account_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_account_edit',
        component: __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_account_create',
        component: __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material',
      redirect: '/inventory/master-material',
      name: 'master_material',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material'
      },
      children: [{
        path: '/',
        name: 'master_material_list',
        component: __WEBPACK_IMPORTED_MODULE_19__views_admin_inventory_master_material_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_material_edit',
        component: __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_create',
        component: __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-detail',
      redirect: '/inventory/master-material-detail',
      name: 'master_material_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_detail'
      },
      children: [{
        path: '/',
        name: 'master_material_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_21__views_admin_inventory_master_material_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_material_detail_edit',
        component: __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_detail_create',
        component: __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-supplier',
      redirect: '/inventory/master-supplier',
      name: 'master_supplier',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_supplier'
      },
      children: [{
        path: '/',
        name: 'master_supplier_list',
        component: __WEBPACK_IMPORTED_MODULE_23__views_admin_inventory_master_supplier_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_supplier_edit',
        component: __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_supplier_create',
        component: __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-genstore',
      redirect: '/inventory/master-genstore',
      name: 'master_genstore',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_genstore'
      },
      children: [{
        path: '/',
        name: 'list',
        component: __WEBPACK_IMPORTED_MODULE_30__views_admin_inventory_master_genstore_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_genstore_edit',
        component: __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_genstore_create',
        component: __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-recipe',
      redirect: '/inventory/master-recipe',
      name: 'master_recipe',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_recipe'
      },
      children: [{
        path: '/',
        name: 'list',
        component: __WEBPACK_IMPORTED_MODULE_32__views_admin_inventory_master_recipe_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_recipe_edit',
        component: __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_recipe_create',
        component: __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-detail-supplier',
      redirect: '/inventory/master-material-detail-supplier',
      name: 'master_material_detail_supplier',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_detail_supplier'
      },
      children: [{
        path: '/',
        name: 'master_material_detail_supplier_list',
        component: __WEBPACK_IMPORTED_MODULE_34__views_admin_inventory_master_material_detail_supplier_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:material_detail_id',
        props: true,
        name: 'master_material_detail_supplier_edit',
        component: __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_detail_supplier_create',
        component: __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-recipe-mapping',
      redirect: '/inventory/master-material-recipe-mapping',
      name: 'master_material_recipe_mapping',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_recipe_mapping'
      },
      children: [{
        path: '/',
        name: 'master_material_recipe_mapping_list',
        component: __WEBPACK_IMPORTED_MODULE_36__views_admin_inventory_master_material_recipe_mapping_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:material_recipe_mapping_id',
        props: true,
        name: 'master_material_recipe_mapping_edit',
        component: __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_recipe_mapping_create',
        component: __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/sync-master',
      redirect: '/inventory/sync-master',
      name: 'sync_master',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'sync_master'
      },
      children: [{
        path: '/',
        name: 'sync_master_list',
        component: __WEBPACK_IMPORTED_MODULE_38__views_admin_inventory_sync_master_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'sync_master_edit',
        component: __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'sync_master_create',
        component: __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/sync-master-detail',
      redirect: '/inventory/sync-master-detail',
      name: 'sync_master_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'sync_master_detail'
      },
      children: [{
        path: '/',
        name: 'sync_master_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_39__views_admin_inventory_sync_master_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }]
    }]
  }, {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__["a" /* default */]
    }, {
      path: '403',
      name: 'Page403',
      component: __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__["a" /* default */]
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_46__views_pages_Page500__["a" /* default */]
    }]
  }]
}));

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18db65fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18db65fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(12);
/* unused harmony reexport Aside */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(179);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(574);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"<i class='icon-list'></i>"}},[_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Today")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"warning"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Meeting with "),_c('strong',[_vm._v("Lucas")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"info"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Skype with "),_c('strong',[_vm._v("Megan")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 5pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-social-skype"}),_vm._v("  On-line ")])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Tomorrow")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"danger"}},[_c('div',[_vm._v("New UI Project - "),_c('strong',[_vm._v("deadline")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  10 - 11pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"success"}},[_c('div',[_c('strong',[_vm._v("#10 Startups.Garden")]),_vm._v(" Meetup")]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"primary"}},[_c('div',[_c('strong',[_vm._v("Team meeting")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 6pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/8.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-speech'></i>"}},[_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-settings'></i>"}},[_c('div',{staticClass:"p-3"},[_c('h6',[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-4"},[_c('small',[_c('b',[_vm._v("Option 1")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 2")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 3")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 4")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("System Utilization")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-4"},[_c('small',[_c('b',[_vm._v("CPU Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":25}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("348 Processes. 1/4 Cores.")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("Memory Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"warning","value":70}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("11444GB/16384MB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 1 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"danger","value":95}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("243GB/256GB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 2 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"success","value":10}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("25GB/256GB")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d4393_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(576);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d4393_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2becae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(578);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe2becae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"ml-auto"},[_vm._v("copyright © 2018 by "),_c('a',{attrs:{"href":"#"}},[_vm._v("Diqit")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f91758_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f91758_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1fb92f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1fb92f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.$auth.user()['info']['avatar'],"alt":_vm.$auth.user()['info']['name']}})]),_vm._v(" "),_c('b-dropdown-header',[_vm._v(_vm._s(_vm.$t('hello'))+" "+_vm._s(_vm.$auth.user()['info']['name']))]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "+_vm._s(_vm.$t('profile')))]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.$t('logout')))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lang"}},[_c('p',{staticStyle:{"display":"none"}},[_c('a',{staticClass:" typo-l6",staticStyle:{"color":"white"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.setLang('vi')}}},[_vm._v("\n      "+_vm._s(_vm.$t('vietnamese'))+"\n    ")]),_vm._v(" "),_c('a',{staticClass:" typo-l6",staticStyle:{"color":"white"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.setLang('en')}}},[_vm._v("\n      "+_vm._s(_vm.$t('english'))+"\n    ")])]),_vm._v(" "),_c('p',[_c('b-form-select',{attrs:{"id":"basicSelect","value":_vm.current_lang,"size":"sm","plain":true,"options":[
                     {
                       text: _vm.$t('vietnamese'),
                       value: 'vi'
                     },
                     {
                       text: _vm.$t('english'),
                       value: 'en'
                     }
                   ]},model:{value:(_vm.current_lang),callback:function ($$v) {_vm.current_lang=$$v},expression:"current_lang"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdownAccnt')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e8c1ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(600);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e8c1ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(588);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 590 */,
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(593);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(595);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(597);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(599);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return (_vm.$auth.check(item.role))?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":_vm.$t(item.name),"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:[(item.children)?[(_vm.$auth.check(item.role))?_c('SidebarNavDropdown',{attrs:{"name":_vm.$t(item.name),"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":_vm.$t(childL1.name),"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":_vm.$t(childL2.name),"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":_vm.$t(childL1.name),"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2):_vm._e()]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[(_vm.$auth.check(item.role))?_c('SidebarNavLink',{attrs:{"name":_vm.$t(item.name),"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}}):_vm._e()],1)]]]:_vm._e()})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('vue-progress-bar'),_vm._v(" "),_c('notifications'),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ff2419_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ff2419_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"select-dropdown"}},[_c('b-dropdown',{attrs:{"slot":this.position,"text":_vm.$t(_vm.value),"variant":_vm.theme},slot:this.position},_vm._l((_vm.values),function(item){return _c('b-dropdown-item',{key:item.id,on:{"click":function($event){_vm.setSelected(item)}}},[_vm._v(_vm._s(_vm.$t(item)))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken() {
    return localStorage.getItem('default_auth_token');
  },
  deleteToken: function deleteToken() {
    return localStorage.removeItem('default_auth_token');
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$auth.check(_vm.model + '.create'))?_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[(_vm.$auth.check(_vm.model + '.update') || _vm.$auth.check(_vm.model + '.detail'))?_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {uuid: item.uuid}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1):_vm._e(),_vm._v(" "),(item.active != 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 1)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.active == 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 0)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6a3bec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a6a3bec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6a3bec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.uuid != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('avatar')}},[_c('b-form-file',{ref:"avatar",attrs:{"id":"avatarData","accept":"image/*"},on:{"change":_vm.previewImage}})],1),_vm._v(" "),_c('div',{staticClass:"image-desktop-preview"},[_c('img',{staticClass:"preview-image",attrs:{"src":_vm.avatarData != '' ? _vm.avatarData : _vm.item.avatar}})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"nameFeedback"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('username'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"usernameFeedback"},model:{value:(_vm.item.username),callback:function ($$v) {_vm.$set(_vm.item, "username", $$v)},expression:"item.username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('email'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"emailFeedback"},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('password'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"password","aria-describedby":"passwordFeedback"},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('confirm_password'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"password","aria-describedby":"passwordConfirmationFeedback"},model:{value:(_vm.item.password_confirmation),callback:function ($$v) {_vm.$set(_vm.item, "password_confirmation", $$v)},expression:"item.password_confirmation"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('store'),"label-cols":3,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.outlets[_vm.$session.get('lang')]},model:{value:(_vm.item.store_code),callback:function ($$v) {_vm.$set(_vm.item, "store_code", $$v)},expression:"item.store_code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.active),callback:function ($$v) {_vm.$set(_vm.item, "active", $$v)},expression:"item.active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('b-col',{key:role.code,attrs:{"cols":"3"}},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox","name":"roles[]"},domProps:{"value":role.id,"checked":_vm._.indexOf(_vm.item.roleIds, role.id) >= 0 ? true : false},on:{"change":_vm.updatePermission}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(role.name))])]),_vm._v(" "),_c('div',{staticClass:"role-permissions"},_vm._l((role.permissions),function(permission){return _c('div',{key:permission.id,staticClass:"role-permission"},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":permission.id}})])}))])}),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_vm._l((_vm.permissions),function(permission){return _c('div',{key:permission.code,staticClass:"col-3"},[_c('label',{class:'switch switch-icon switch-' + (_vm.checkPermissionInRole(permission.id) ? 'secondary' : 'primary')},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox","name":"roles[]"},domProps:{"value":permission.id,"checked":_vm.checkPermission(permission.id)},on:{"change":_vm.updateRole}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_vm._v(_vm._s(permission.name)+"\n                "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(permission.description))])])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.uuid != null && _vm.$auth.check(_vm.model + '.update'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.uuid == null && _vm.$auth.check(_vm.model + '.create'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n            ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4cd99f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(630);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4cd99f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$auth.check(_vm.model + '.create'))?_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[(_vm.$auth.check(_vm.model + '.update') || _vm.$auth.check(_vm.model + '.detail'))?_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {uuid: item.uuid}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1):_vm._e(),_vm._v(" "),(item.active != 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 1)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.active == 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 0)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fb42ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49fb42ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fb42ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.uuid != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"nameFeedback"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('description'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.description),callback:function ($$v) {_vm.$set(_vm.item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"readonly":""},model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.active),callback:function ($$v) {_vm.$set(_vm.item, "active", $$v)},expression:"item.active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},on:{"change":_vm.checkAll}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_c('b',[_vm._v("All")])])]),_vm._v(" "),_vm._l((_vm.permissionsData),function(permission){return _c('div',{key:permission.code,staticClass:"col-3"},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.permissionIds),expression:"item.permissionIds"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":permission.id,"checked":Array.isArray(_vm.item.permissionIds)?_vm._i(_vm.item.permissionIds,permission.id)>-1:(_vm.item.permissionIds)},on:{"change":function($event){var $$a=_vm.item.permissionIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=permission.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.item.permissionIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.item.permissionIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.item, "permissionIds", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_vm._v(_vm._s(permission.name)+"\n                "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(permission.description))])])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.uuid != null && _vm.$auth.check(_vm.model + '.update'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.uuid == null && _vm.$auth.check(_vm.model + '.create'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n            ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec79af0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aec79af0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$auth.check(_vm.model + '.create'))?_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[(_vm.$auth.check(_vm.model + '.update') || _vm.$auth.check(_vm.model + '.detail'))?_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {uuid: item.uuid}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1):_vm._e(),_vm._v(" "),(item.active != 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 1)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.active == 1 && _vm.$auth.check(_vm.model + '.update.status'))?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.uuid, 0)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c206590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c206590"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c206590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.uuid != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"nameFeedback"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('description'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.description),callback:function ($$v) {_vm.$set(_vm.item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"readonly":""},model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.active),callback:function ($$v) {_vm.$set(_vm.item, "active", $$v)},expression:"item.active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.uuid != null && _vm.$auth.check(_vm.model + '.update'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.uuid == null && _vm.$auth.check(_vm.model + '.create'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n            ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af6fe804_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(640);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af6fe804_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('role')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"7"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$auth.check(_vm.model + '.create'))?_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[(_vm.$auth.check(_vm.model + '.update') || _vm.$auth.check(_vm.model + '.detail'))?_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {uuid: item.uuid}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1):_vm._e()],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa8acfe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa8acfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa8acfe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */,
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.uuid != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"aria-describedby":"nameFeedback"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('description'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.description),callback:function ($$v) {_vm.$set(_vm.item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                  "+_vm._s(_vm.$t('config'))+"\n                  "),_c('label',{directives:[{name:"b-toggle",rawName:"v-b-toggle.config_content",modifiers:{"config_content":true}}],staticClass:"switch switch-sm switch-text switch-info float-right mb-0",on:{"click":_vm.updateConfigStatus}},[(_vm.configStatus == 1)?_c('i',{staticClass:"fa fa-chevron-up"}):_vm._e(),_vm._v(" "),(_vm.configStatus == 0)?_c('i',{staticClass:"fa fa-chevron-down"}):_vm._e()])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"config_content"}},[_vm._l((_vm.item.configs),function(config,c){return _c('b-row',{key:config.id},[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('group'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(config.group),callback:function ($$v) {_vm.$set(config, "group", $$v)},expression:"config.group"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('key'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(config.key),callback:function ($$v) {_vm.$set(config, "key", $$v)},expression:"config.key"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('value'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(config.value),callback:function ($$v) {_vm.$set(config, "value", $$v)},expression:"config.value"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.removeConfig(c)}}},[_c('i',{staticClass:"fa fa-trash-o"})])],1)],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.addConfig}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  "+_vm._s(_vm.$t('config')))])],1)],1)],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                  "+_vm._s(_vm.$t('customizes'))+"\n                  "),_c('label',{directives:[{name:"b-toggle",rawName:"v-b-toggle.customize_content",modifiers:{"customize_content":true}}],staticClass:"switch switch-sm switch-text switch-info float-right mb-0",on:{"click":_vm.updateCustomizeStatus}},[(_vm.customizeStatus == 1)?_c('i',{staticClass:"fa fa-chevron-up"}):_vm._e(),_vm._v(" "),(_vm.customizeStatus == 0)?_c('i',{staticClass:"fa fa-chevron-down"}):_vm._e()])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"customize_content"}},[_vm._l((_vm.item.customizes),function(customize,c){return _c('b-row',{key:customize.id},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('group'),"label-cols":3,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.groups},model:{value:(_vm.item.customizes[c].group),callback:function ($$v) {_vm.$set(_vm.item.customizes[c], "group", $$v)},expression:"item.customizes[c].group"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.removeGroup(c)}}},[_c('i',{staticClass:"fa fa-minus"}),_vm._v("  "+_vm._s(_vm.$t('group')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_vm._l((_vm.item.customizes[c].fields),function(field,f){return _c('b-row',{key:field.id},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].name),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f], "name", $$v)},expression:"item.customizes[c].fields[f].name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tag'),"label-cols":3,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.tags},on:{"change":function($event){_vm.updateTag (c, f)}},model:{value:(_vm.item.customizes[c].fields[f].tag),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f], "tag", $$v)},expression:"item.customizes[c].fields[f].tag"}})],1)],1),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'text_box')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('type'),"label-cols":3,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.types},model:{value:(_vm.item.customizes[c].fields[f].attribute.type),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "type", $$v)},expression:"item.customizes[c].fields[f].attribute.type"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('class'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.class),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "class", $$v)},expression:"item.customizes[c].fields[f].attribute.class"}})],1)],1),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'date_box')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('default'),"label-cols":3,"horizontal":true}},[_c('masked-input',{staticClass:"form-control",attrs:{"type":"text","name":"date","mask":[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],"guide":true,"placeholderChar":"_","showMask":true,"keepCharPositions":true},model:{value:(_vm.item.customizes[c].fields[f].attribute.default),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "default", $$v)},expression:"item.customizes[c].fields[f].attribute.default"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'text_box')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('default'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.default),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "default", $$v)},expression:"item.customizes[c].fields[f].attribute.default"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'text_box' || _vm.item.customizes[c].fields[f].tag == 'text_area')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('place_holder'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.place_holder),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "place_holder", $$v)},expression:"item.customizes[c].fields[f].attribute.place_holder"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'switch')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('check_value'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.check_value),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "check_value", $$v)},expression:"item.customizes[c].fields[f].attribute.check_value"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'switch')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('uncheck_value'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.uncheck_value),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "uncheck_value", $$v)},expression:"item.customizes[c].fields[f].attribute.uncheck_value"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'text_area')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('rows'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.rows),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "rows", $$v)},expression:"item.customizes[c].fields[f].attribute.rows"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'select')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('multiple'),"label-cols":3,"horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.customizes[c].fields[f].attribute.multiple,"value":1,"uncheckedValue":0},model:{value:(_vm.item.customizes[c].fields[f].attribute.multiple),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute, "multiple", $$v)},expression:"item.customizes[c].fields[f].attribute.multiple"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1):_vm._e(),_vm._v(" "),(_vm.item.customizes[c].fields[f].tag == 'select' || _vm.item.customizes[c].fields[f].tag == 'check_box' || _vm.item.customizes[c].fields[f].tag == 'radio_group')?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('options'),"label-cols":2,"horizontal":true}},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('text')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('value')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.item.customizes[c].fields[f].attribute.options),function(option,o){return _c('tr',{key:option.id},[_c('td',[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.options[o].text),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute.options[o], "text", $$v)},expression:"item.customizes[c].fields[f].attribute.options[o].text"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.customizes[c].fields[f].attribute.options[o].value),callback:function ($$v) {_vm.$set(_vm.item.customizes[c].fields[f].attribute.options[o], "value", $$v)},expression:"item.customizes[c].fields[f].attribute.options[o].value"}})],1),_vm._v(" "),_c('td',[_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.removeOption(c, f, o)}}},[_c('i',{staticClass:"fa fa-minus"})])],1)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.addOption(c, f)}}},[_c('i',{staticClass:"fa fa-plus"})])],1)])],2)])])],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.removeField(c, f)}}},[_c('i',{staticClass:"fa fa-minus"}),_vm._v("  "+_vm._s(_vm.$t('field')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"clearfix"},[_c('hr')])])],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){_vm.addField(c)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  "+_vm._s(_vm.$t('field')))])],1)],1)],2),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"clearfix"},[_c('hr')])])],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.addGroup}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  "+_vm._s(_vm.$t('group')))])],1)],1)],2)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.uuid != null && _vm.$auth.check(_vm.model + '.update'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update')))]):_vm._e(),_vm._v(" "),(_vm.uuid == null && _vm.$auth.check(_vm.model + '.create'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save')))]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d22b0d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(646);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d22b0d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-group-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebad454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(648);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebad454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-group-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('group_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('group_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e5d114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(650);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e5d114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-type-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c0c280_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47c0c280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c0c280_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-type-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('type_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('type_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('type_description'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.description),callback:function ($$v) {_vm.$set(_vm.item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b5b36a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(655);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b5b36a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-account-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b5dd0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b5dd0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-account-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('account_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('account_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f4275f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f4275f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e10070e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(661);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e10070e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('group_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.groups,"disabled":_vm.id},model:{value:(_vm.item.group_id),callback:function ($$v) {_vm.$set(_vm.item, "group_id", $$v)},expression:"item.group_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('type'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.types,"disabled":_vm.id},model:{value:(_vm.item.type_id),callback:function ($$v) {_vm.$set(_vm.item, "type_id", $$v)},expression:"item.type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('account_code'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.accounts},model:{value:(_vm.item.account_id),callback:function ($$v) {_vm.$set(_vm.item, "account_id", $$v)},expression:"item.account_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('genstore_code'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.genstores},model:{value:(_vm.item.genstore_id),callback:function ($$v) {_vm.$set(_vm.item, "genstore_id", $$v)},expression:"item.genstore_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('material_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('material_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('net_weight'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"number"},model:{value:(_vm.item.recipe_rate),callback:function ($$v) {_vm.$set(_vm.item, "recipe_rate", $$v)},expression:"item.recipe_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('material_uom'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.recipe_rate_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "recipe_rate_uom_id", $$v)},expression:"item.recipe_rate_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd333b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd333b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-detail-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044f98a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(666);
function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-044f98a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_044f98a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-detail-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('material_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.materials},model:{value:(_vm.item.material_id),callback:function ($$v) {_vm.$set(_vm.item, "material_id", $$v)},expression:"item.material_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_uom_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.supplier_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "supplier_uom_id", $$v)},expression:"item.supplier_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('smaller_uom_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.smaller_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "smaller_uom_id", $$v)},expression:"item.smaller_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('smaller_uom_detail_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.smaller_uom_details},model:{value:(_vm.item.smaller_uom_detail_id),callback:function ($$v) {_vm.$set(_vm.item, "smaller_uom_detail_id", $$v)},expression:"item.smaller_uom_detail_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('outlet_uom_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.outlet_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "outlet_uom_id", $$v)},expression:"item.outlet_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('outlet_uom_detail_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.outlet_uom_details},model:{value:(_vm.item.outlet_uom_detail_id),callback:function ($$v) {_vm.$set(_vm.item, "outlet_uom_detail_id", $$v)},expression:"item.outlet_uom_detail_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('recipe_uom_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.recipe_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "recipe_uom_id", $$v)},expression:"item.recipe_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('recipe_uom_detail_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.recipe_uom_details},model:{value:(_vm.item.recipe_uom_detail_id),callback:function ($$v) {_vm.$set(_vm.item, "recipe_uom_detail_id", $$v)},expression:"item.recipe_uom_detail_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('report_uom_id'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.report_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "report_uom_id", $$v)},expression:"item.report_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('material_detail_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":""},model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('material_detail_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('fixed_unit'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.fixed_unit_id),callback:function ($$v) {_vm.$set(_vm.item, "fixed_unit_id", $$v)},expression:"item.fixed_unit_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620fd2dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(668);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620fd2dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-supplier-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('supplier_import_do')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0, '')}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1, '')}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_import_do == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, '', 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_import_do != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, '', 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063bf47d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(670);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063bf47d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-supplier-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('supplier_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_address'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.address),callback:function ($$v) {_vm.$set(_vm.item, "address", $$v)},expression:"item.address"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_phone'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.phone),callback:function ($$v) {_vm.$set(_vm.item, "phone", $$v)},expression:"item.phone"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_fax'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.fax),callback:function ($$v) {_vm.$set(_vm.item, "fax", $$v)},expression:"item.fax"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_terms_of_payment'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.terms_of_payment),callback:function ($$v) {_vm.$set(_vm.item, "terms_of_payment", $$v)},expression:"item.terms_of_payment"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier_import_do'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_import_do,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_import_do),callback:function ($$v) {_vm.$set(_vm.item, "is_import_do", $$v)},expression:"item.is_import_do"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('tax'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_tax,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_tax),callback:function ($$v) {_vm.$set(_vm.item, "is_tax", $$v)},expression:"item.is_tax"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8550d0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(673);
function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8550d0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8550d0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-uom-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_vm._v(" "),(_vm.item.id == '')?_c('strong',[_vm._v(_vm._s(_vm.$t('create')))]):_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"6","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('uom_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f04d7ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(675);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f04d7ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-uom-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5634237e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5634237e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5634237e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-uom-detail-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_vm._v(" "),(_vm.item.id == '')?_c('strong',[_vm._v(_vm._s(_vm.$t('create')))]):_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"6","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('from_uom_name'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.from_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "from_uom_id", $$v)},expression:"item.from_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('from_uom_qty'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.from_uom_qty),callback:function ($$v) {_vm.$set(_vm.item, "from_uom_qty", $$v)},expression:"item.from_uom_qty"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('to_uom_name'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.to_uom_id),callback:function ($$v) {_vm.$set(_vm.item, "to_uom_id", $$v)},expression:"item.to_uom_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('to_uom_qty'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.to_uom_qty),callback:function ($$v) {_vm.$set(_vm.item, "to_uom_qty", $$v)},expression:"item.to_uom_qty"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('conversion_rate'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.conversion_rate),callback:function ($$v) {_vm.$set(_vm.item, "conversion_rate", $$v)},expression:"item.conversion_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cc9721_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(680);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cc9721_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-uom-detail-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104aeba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(682);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104aeba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-genstore-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('genstore_code'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('genstore_name'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('genstore_description'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.description),callback:function ($$v) {_vm.$set(_vm.item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef1572_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(684);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef1572_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-genstore-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281d41c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-281d41c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281d41c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchAll */
/* unused harmony export changeStatusItem */
/* unused harmony export changeStatusDefaultItem */
/* unused harmony export get */
/* unused harmony export create */
/* unused harmony export update */
/* harmony export (immutable) */ __webpack_exports__["a"] = getMasterRecipeDetailByRecipe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/update-status',
    method: 'put',
    data: data
  });
}

function changeStatusDefaultItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/update-status-default',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: procss.env.BASE_URL_INVENTORY + '/master-recipe-detail/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterRecipeDetailByRecipe(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/master-recipe-detail/get-by-recipe',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fa fa-align-justify"}),_vm._v(" "),(_vm.item.id == '')?_c('strong',[_vm._v(_vm._s(_vm.$t('create')))]):_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"align-self":"center"}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('code'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.code),callback:function ($$v) {_vm.$set(_vm.item, "code", $$v)},expression:"item.code"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('uom_name'),"label-cols":2,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.uoms},model:{value:(_vm.item.uom_id),callback:function ($$v) {_vm.$set(_vm.item, "uom_id", $$v)},expression:"item.uom_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('plucode'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.plucode),callback:function ($$v) {_vm.$set(_vm.item, "plucode", $$v)},expression:"item.plucode"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sku'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"placeholder":"Ie. 224300006,213830015,213830014"},model:{value:(_vm.item.sku),callback:function ($$v) {_vm.$set(_vm.item, "sku", $$v)},expression:"item.sku"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('usage'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.usage),callback:function ($$v) {_vm.$set(_vm.item, "usage", $$v)},expression:"item.usage"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('expired_in'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.expired_in),callback:function ($$v) {_vm.$set(_vm.item, "expired_in", $$v)},expression:"item.expired_in"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('price'),"label-cols":2,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":""},model:{value:(_vm.item.price),callback:function ($$v) {_vm.$set(_vm.item, "price", $$v)},expression:"item.price"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"2","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('daily_batch'),"label-cols":"2","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_daily_batch,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_daily_batch),callback:function ($$v) {_vm.$set(_vm.item, "is_daily_batch", $$v)},expression:"item.is_daily_batch"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),[_c('div',[_c('b-button',{on:{"click":_vm.addNew}},[_vm._v("Add new")]),_vm._v(" "),_c('b-modal',{ref:"my-modal",attrs:{"id":"modalPrevent","title":"Add recipe detail"},on:{"ok":_vm.handleAdd}},[_c('form',{attrs:{"id":"add-recipe-detail"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.hideModal($event)}}},[_c('b-form-group',[_c('b-form-radio-group',{attrs:{"id":"choose-method","name":"radioSubComponent"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('b-form-radio',{attrs:{"value":"true"},on:{"change":function($event){_vm.switchTab(true)}}},[_vm._v("Using material")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"false"},on:{"change":function($event){_vm.switchTab(false)}}},[_vm._v("Using others recipe")])],1)],1),_vm._v(" "),(_vm.isHidden)?_c('b-form',{attrs:{"id":"using-material"}},[_c('b-form-group',{attrs:{"label":_vm.$t('material'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.materials},model:{value:(_vm.popup.material),callback:function ($$v) {_vm.$set(_vm.popup, "material", $$v)},expression:"popup.material"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isHidden)?_c('b-form',{attrs:{"id":"using-others-recipe"}},[_c('b-form-group',{attrs:{"label":_vm.$t('recipe'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.recipes},model:{value:(_vm.popup.recipe),callback:function ($$v) {_vm.$set(_vm.popup, "recipe", $$v)},expression:"popup.recipe"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('recipe_detail_usage'),"label-cols":3,"horizontal":true}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.popup.recipe_detail_usage),callback:function ($$v) {_vm.$set(_vm.popup, "recipe_detail_usage", $$v)},expression:"popup.recipe_detail_usage"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('recipe_detail_status'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","value":1,"uncheckedValue":0},model:{value:(_vm.popup.recipe_detail_status),callback:function ($$v) {_vm.$set(_vm.popup, "recipe_detail_status", $$v)},expression:"popup.recipe_detail_status"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)])],1)],_vm._v(" "),_c('div',{staticClass:"row"},[[_c('b-table',{ref:"table",attrs:{"items":_vm.data_table,"fields":_vm.columns_table},scopedSlots:_vm._u([_vm._l((_vm.formatted),function(field){return {key:field,fn:function(row){return [_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.editRecipeDeTail(row.index, row.item)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.removeRecipeDeTail(row.index)}}},[_vm._v("Remove")])]}}})])})]],2),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v("\n                  "+_vm._s(_vm.$t('back'))+"\n                ")])],1),_vm._v(" "),(_vm.id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v("\n                "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v("\n                "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],2)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da66b952_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da66b952_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-recipe-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('daily_batch')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0, 'active')}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1, 'active')}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_daily_batch == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.id, 0, 'daily_batch')}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_daily_batch != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.id, 1, 'daily_batch')}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a704748_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(692);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a704748_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-supplier-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_vm._v(" "),(_vm.item.new)?_c('strong',[_vm._v(_vm._s(_vm.$t('create')))]):_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('material_detail'),"label-cols":3,"horizontal":true}},[(_vm.item.new)?_c('v-select',{attrs:{"options":_vm.material_details},model:{value:(_vm.item.material_detail_id),callback:function ($$v) {_vm.$set(_vm.item, "material_detail_id", $$v)},expression:"item.material_detail_id"}}):_c('v-select',{attrs:{"options":_vm.material_details,"disabled":""},model:{value:(_vm.item.material_detail_id),callback:function ($$v) {_vm.$set(_vm.item, "material_detail_id", $$v)},expression:"item.material_detail_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('supplier'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"multiple":"multiple","options":_vm.suppliers},model:{value:(_vm.item.supplier_ids),callback:function ($$v) {_vm.$set(_vm.item, "supplier_ids", $$v)},expression:"item.supplier_ids"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('active'),"label-cols":"3","horizontal":true}},[_c('c-switch',_vm._b({attrs:{"type":"icon","variant":"primary","checked":_vm.item.is_active,"value":1,"uncheckedValue":0},model:{value:(_vm.item.is_active),callback:function ($$v) {_vm.$set(_vm.item, "is_active", $$v)},expression:"item.is_active"}},'c-switch',{on: '\uf00c', off: '\uf00d'},false))],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.material_detail_id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.material_detail_id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d117f23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(694);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d117f23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-detail-supplier-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,staticClass:"text-left",class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('active')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,staticClass:"text-left",attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row"}},[(item.is_active == 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.updateStatusItem(item.material_detail_id, 0)}}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(item.is_active != 1)?_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.updateStatusItem(item.material_detail_id, 1)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {material_detail_id: item.material_detail_id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa8e300_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(696);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa8e300_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-supplier-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_vm._v(" "),(_vm.item.new)?_c('strong',[_vm._v(_vm._s(_vm.$t('create')))]):_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"9","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('source_type'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.source_type},model:{value:(_vm.item.source_type),callback:function ($$v) {_vm.$set(_vm.item, "source_type", $$v)},expression:"item.source_type"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('source_code'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.source_codes},model:{value:(_vm.item.source_code),callback:function ($$v) {_vm.$set(_vm.item, "source_code", $$v)},expression:"item.source_code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('destination_type'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.source_type},model:{value:(_vm.item.destination_type),callback:function ($$v) {_vm.$set(_vm.item, "destination_type", $$v)},expression:"item.destination_type"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('destination_code'),"label-cols":3,"horizontal":true}},[_c('v-select',{attrs:{"options":_vm.destination_codes},model:{value:(_vm.item.destination_code),callback:function ($$v) {_vm.$set(_vm.item, "destination_code", $$v)},expression:"item.destination_code"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.material_recipe_mapping_id != null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.material_recipe_mapping_id == null)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8f8b4b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(698);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8f8b4b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-material-detail-supplier-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('active'), value: 1}, {text: _vm.$t('inactive'), value: 0}]},model:{value:(_vm.filter.actived),callback:function ($$v) {_vm.$set(_vm.filter, "actived", $$v)},expression:"filter.actived"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('source_type')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('source_code')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('destination_type')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('destination_code')))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,staticClass:"text-left",attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_edit', params: {material_recipe_mapping_id: item.id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-edit"})])],1)],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce259ff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ce259ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce259ff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTableSyncList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function getTableSyncList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/table-sync/common-list',
    method: 'get'
  });
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-group-form"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),(_vm.item.id != null)?_c('b-form',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"6","align-self":"center"}},[_c('b-form-group',{attrs:{"label":_vm.$t('version'),"label-cols":3}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.item.version),callback:function ($$v) {_vm.$set(_vm.item, "version", $$v)},expression:"item.version"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},on:{"change":_vm.checkAll}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_c('b',[_vm._v("All")])])]),_vm._v(" "),_vm._l((_vm.tableSyncData),function(table){return _c('b-col',{key:table.id,attrs:{"cols":"3"}},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tableSyncIds),expression:"item.tableSyncIds"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":table.id,"checked":Array.isArray(_vm.item.tableSyncIds)?_vm._i(_vm.item.tableSyncIds,table.id)>-1:(_vm.item.tableSyncIds)},on:{"change":function($event){var $$a=_vm.item.tableSyncIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=table.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.item.tableSyncIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.item.tableSyncIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.item, "tableSyncIds", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_vm._v(_vm._s(table.table_name))])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{name: _vm.model + '_list'}}},[_c('b-button',{attrs:{"variant":"default"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('back')))])],1),_vm._v(" "),(_vm.id != null && _vm.$auth.check(_vm.model + '.update'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.updateItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('update'))+"\n              ")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.createItem}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+"\n              ")])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2261582a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(705);
function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2261582a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2261582a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync-master-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                    ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',[_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$t('action')))])],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},[_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                        "+_vm._s(item[field.name])+"\n                      ")]):_vm._e()])}),_vm._v(" "),_c('td',{attrs:{"scope":"row","width":"130"}},[_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.showStores(item.id)}}},[_vm._v("\n                        Confirm\n                      ")])],1)],2)}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},on:{"change":_vm.checkAll}}),_vm._v(" "),_c('b-modal',{ref:"store-modal",attrs:{"size":"lg","title":"Sync master inventory into Store"},on:{"ok":_vm.confirm}},[_c('form',{staticClass:"row",attrs:{"id":"list-store"}},[_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},on:{"change":_vm.checkAll}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_c('b',[_vm._v("All")])])]),_vm._v(" "),_vm._l((_vm.popup.storeData),function(store){return _c('b-col',{key:store.store_code,attrs:{"cols":"6"}},[_c('label',{staticClass:"switch switch-icon switch-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.storeIds),expression:"item.storeIds"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":store.store_code,"checked":Array.isArray(_vm.item.storeIds)?_vm._i(_vm.item.storeIds,store.store_code)>-1:(_vm.item.storeIds)},on:{"change":function($event){var $$a=_vm.item.storeIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=store.store_code,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.item.storeIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.item.storeIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.item, "storeIds", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_c('legend',{staticClass:"col-form-label"},[_vm._v(_vm._s(store.name))])])})],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441cacc0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(708);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441cacc0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(11);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://api-phr.ch.diqit.io/v1/inventory" + '/sync-master-detail/list',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync-master-detail-list"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"card-actions"})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: _vm.$t('already_sync_to_pos'), value: 1}, {text: _vm.$t('not_sync_to_pos'), value: 0}]},model:{value:(_vm.filter.is_sync),callback:function ($$v) {_vm.$set(_vm.filter, "is_sync", $$v)},expression:"filter.is_sync"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-input-group',[_c('select-dropdown',{attrs:{"options":_vm.filter.options,"selected":_vm.filter.selected,"position":"prepend","all":true},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-input-group-append',[_c('b-btn',{on:{"click":function($event){_vm.refreshData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$auth.check(_vm.model + '.create'))?_c('b-col',{attrs:{"cols":"1"}},[_c('router-link',{attrs:{"to":{name: _vm.model + '_create'}}},[_c('b-button',{attrs:{"variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('create'))+"\n                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}))}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5f93dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c5f93dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5f93dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */,
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 245,
	"./af.js": 245,
	"./ar": 246,
	"./ar-dz": 247,
	"./ar-dz.js": 247,
	"./ar-kw": 248,
	"./ar-kw.js": 248,
	"./ar-ly": 249,
	"./ar-ly.js": 249,
	"./ar-ma": 250,
	"./ar-ma.js": 250,
	"./ar-sa": 251,
	"./ar-sa.js": 251,
	"./ar-tn": 252,
	"./ar-tn.js": 252,
	"./ar.js": 246,
	"./az": 253,
	"./az.js": 253,
	"./be": 254,
	"./be.js": 254,
	"./bg": 255,
	"./bg.js": 255,
	"./bm": 256,
	"./bm.js": 256,
	"./bn": 257,
	"./bn.js": 257,
	"./bo": 258,
	"./bo.js": 258,
	"./br": 259,
	"./br.js": 259,
	"./bs": 260,
	"./bs.js": 260,
	"./ca": 261,
	"./ca.js": 261,
	"./cs": 262,
	"./cs.js": 262,
	"./cv": 263,
	"./cv.js": 263,
	"./cy": 264,
	"./cy.js": 264,
	"./da": 265,
	"./da.js": 265,
	"./de": 266,
	"./de-at": 267,
	"./de-at.js": 267,
	"./de-ch": 268,
	"./de-ch.js": 268,
	"./de.js": 266,
	"./dv": 269,
	"./dv.js": 269,
	"./el": 270,
	"./el.js": 270,
	"./en-SG": 271,
	"./en-SG.js": 271,
	"./en-au": 272,
	"./en-au.js": 272,
	"./en-ca": 273,
	"./en-ca.js": 273,
	"./en-gb": 274,
	"./en-gb.js": 274,
	"./en-ie": 275,
	"./en-ie.js": 275,
	"./en-il": 276,
	"./en-il.js": 276,
	"./en-nz": 277,
	"./en-nz.js": 277,
	"./eo": 278,
	"./eo.js": 278,
	"./es": 279,
	"./es-do": 280,
	"./es-do.js": 280,
	"./es-us": 281,
	"./es-us.js": 281,
	"./es.js": 279,
	"./et": 282,
	"./et.js": 282,
	"./eu": 283,
	"./eu.js": 283,
	"./fa": 284,
	"./fa.js": 284,
	"./fi": 285,
	"./fi.js": 285,
	"./fo": 286,
	"./fo.js": 286,
	"./fr": 287,
	"./fr-ca": 288,
	"./fr-ca.js": 288,
	"./fr-ch": 289,
	"./fr-ch.js": 289,
	"./fr.js": 287,
	"./fy": 290,
	"./fy.js": 290,
	"./ga": 291,
	"./ga.js": 291,
	"./gd": 292,
	"./gd.js": 292,
	"./gl": 293,
	"./gl.js": 293,
	"./gom-latn": 294,
	"./gom-latn.js": 294,
	"./gu": 295,
	"./gu.js": 295,
	"./he": 296,
	"./he.js": 296,
	"./hi": 297,
	"./hi.js": 297,
	"./hr": 298,
	"./hr.js": 298,
	"./hu": 299,
	"./hu.js": 299,
	"./hy-am": 300,
	"./hy-am.js": 300,
	"./id": 301,
	"./id.js": 301,
	"./is": 302,
	"./is.js": 302,
	"./it": 303,
	"./it-ch": 304,
	"./it-ch.js": 304,
	"./it.js": 303,
	"./ja": 305,
	"./ja.js": 305,
	"./jv": 306,
	"./jv.js": 306,
	"./ka": 307,
	"./ka.js": 307,
	"./kk": 308,
	"./kk.js": 308,
	"./km": 309,
	"./km.js": 309,
	"./kn": 310,
	"./kn.js": 310,
	"./ko": 311,
	"./ko.js": 311,
	"./ku": 312,
	"./ku.js": 312,
	"./ky": 313,
	"./ky.js": 313,
	"./lb": 314,
	"./lb.js": 314,
	"./lo": 315,
	"./lo.js": 315,
	"./lt": 316,
	"./lt.js": 316,
	"./lv": 317,
	"./lv.js": 317,
	"./me": 318,
	"./me.js": 318,
	"./mi": 319,
	"./mi.js": 319,
	"./mk": 320,
	"./mk.js": 320,
	"./ml": 321,
	"./ml.js": 321,
	"./mn": 322,
	"./mn.js": 322,
	"./mr": 323,
	"./mr.js": 323,
	"./ms": 324,
	"./ms-my": 325,
	"./ms-my.js": 325,
	"./ms.js": 324,
	"./mt": 326,
	"./mt.js": 326,
	"./my": 327,
	"./my.js": 327,
	"./nb": 328,
	"./nb.js": 328,
	"./ne": 329,
	"./ne.js": 329,
	"./nl": 330,
	"./nl-be": 331,
	"./nl-be.js": 331,
	"./nl.js": 330,
	"./nn": 332,
	"./nn.js": 332,
	"./pa-in": 333,
	"./pa-in.js": 333,
	"./pl": 334,
	"./pl.js": 334,
	"./pt": 335,
	"./pt-br": 336,
	"./pt-br.js": 336,
	"./pt.js": 335,
	"./ro": 337,
	"./ro.js": 337,
	"./ru": 338,
	"./ru.js": 338,
	"./sd": 339,
	"./sd.js": 339,
	"./se": 340,
	"./se.js": 340,
	"./si": 341,
	"./si.js": 341,
	"./sk": 342,
	"./sk.js": 342,
	"./sl": 343,
	"./sl.js": 343,
	"./sq": 344,
	"./sq.js": 344,
	"./sr": 345,
	"./sr-cyrl": 346,
	"./sr-cyrl.js": 346,
	"./sr.js": 345,
	"./ss": 347,
	"./ss.js": 347,
	"./sv": 348,
	"./sv.js": 348,
	"./sw": 349,
	"./sw.js": 349,
	"./ta": 350,
	"./ta.js": 350,
	"./te": 351,
	"./te.js": 351,
	"./tet": 352,
	"./tet.js": 352,
	"./tg": 353,
	"./tg.js": 353,
	"./th": 354,
	"./th.js": 354,
	"./tl-ph": 355,
	"./tl-ph.js": 355,
	"./tlh": 356,
	"./tlh.js": 356,
	"./tr": 357,
	"./tr.js": 357,
	"./tzl": 358,
	"./tzl.js": 358,
	"./tzm": 359,
	"./tzm-latn": 360,
	"./tzm-latn.js": 360,
	"./tzm.js": 359,
	"./ug-cn": 361,
	"./ug-cn.js": 361,
	"./uk": 362,
	"./uk.js": 362,
	"./ur": 363,
	"./ur.js": 363,
	"./uz": 364,
	"./uz-latn": 365,
	"./uz-latn.js": 365,
	"./uz.js": 364,
	"./vi": 366,
	"./vi.js": 366,
	"./x-pseudo": 367,
	"./x-pseudo.js": 367,
	"./yo": 368,
	"./yo.js": 368,
	"./zh-cn": 369,
	"./zh-cn.js": 369,
	"./zh-hk": 370,
	"./zh-hk.js": 370,
	"./zh-tw": 371,
	"./zh-tw.js": 371
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;

/***/ }),
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"3.1.0","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","prepublishOnly":"yarn run lint && yarn run test && yarn run build"},"dependencies":{},"peerDependencies":{"chart.js":"2.7.x"},"devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-square",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('square-loader',{attrs:{"loading":true,"color":"#26A65B","size":"50px"}})],1):_vm._e(),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('outlet'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('v-select',{attrs:{"options":_vm.outlets[_vm.$session.get('lang')]},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('div',{staticClass:"process-container bg-secondary"},[_c('div',{staticClass:"current bg-primary",style:('width: ' + _vm.current + '%')}),_vm._v(" "),_c('div',{staticClass:"target bg-danger",style:('margin-left: ' + _vm.target + '%'),attrs:{"id":"target"}}),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.show_target,"target":"target","placement":"bottom"},on:{"update:show":function($event){_vm.show_target=$event}}},[_vm._v("\n            "+_vm._s(_vm._f("numeral")(_vm.target_sales,'0,0'))+"\n          ")])],1)])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-money"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_sale')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-shopping-basket"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales/_vm.total_cheque,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('average_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-bullhorn"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.sos,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('sos')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.sale_by_channel_labels[_vm.$session.get('lang')],"datasets":_vm.sale_by_channel_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_by_channel')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.sale_by_type_labels[_vm.$session.get('lang')],"datasets":_vm.sale_by_type_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_by_type')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.cheque_by_channel_labels[_vm.$session.get('lang')],"datasets":_vm.cheque_by_channel_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cheque_by_channel')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.cheque_by_type_labels[_vm.$session.get('lang')],"datasets":_vm.cheque_by_type_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cheque_by_type')))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f8685c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__(730);
function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05f8685c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f8685c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('date_range'),"label-cols":3,"label-class":"text-right","horizontal":true}},[_c('date-range-picker',{attrs:{"startDate":_vm.startDate,"endDate":_vm.endDate,"opens":"right","localeData":{ format: 'DD/MM/YYYY' }},on:{"update":_vm.updateDateRange}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('outlet'),"label-cols":3,"label-class":"text-right","horizontal":true}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('all'), value: null}, {text: 'Outlet 1', value: 1}, {text: 'Outlet 2', value: 2}]},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('type'),"label-cols":3,"label-class":"text-right","horizontal":true}},[_c('b-form-select',{attrs:{"options":[{text: _vm.$t('daily'), value: 'daily'}, {text: _vm.$t('weekly'), value: 'weekly'}, {text: _vm.$t('monthly'), value: 'monthly'}]},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('div',{staticClass:"process-container bg-secondary"},[_c('div',{staticClass:"current bg-primary",style:('width: ' + _vm.current + '%')}),_vm._v(" "),_c('div',{staticClass:"target bg-danger",style:('margin-left: ' + _vm.target + '%'),attrs:{"id":"target"}}),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.show_target,"target":"target","placement":"bottom"},on:{"update:show":function($event){_vm.show_target=$event}}},[_vm._v("\n            "+_vm._s(_vm._f("numeral")(_vm.target_sales,'0,0'))+"\n          ")])],1)])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-money"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_sale')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-shopping-basket"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales/_vm.total_cheque,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('average_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right"},[_c('i',{staticClass:"fa fa-bullhorn"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.sos,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('sos')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('bar',{attrs:{"labels":_vm.sale_trend_labels[_vm.$session.get('lang')],"datasets":_vm.sale_trend_datasets[_vm.$session.get('lang')]}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_trend')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('bar',{attrs:{"labels":_vm.cheque_trend_labels[_vm.$session.get('lang')],"datasets":_vm.cheque_trend_datasets[_vm.$session.get('lang')]}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cheque_trend')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.sale_by_channel_labels[_vm.$session.get('lang')],"datasets":_vm.sale_by_channel_datasets[_vm.$session.get('lang')]}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_by_channel')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesHistory_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe6037c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesHistory_vue__ = __webpack_require__(733);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fe6037c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe6037c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('square-loader',{attrs:{"loading":true,"color":"#26A65B","size":"50px"}})],1):_vm._e(),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"7"}},[_c('b-form-group',{attrs:{"label":_vm.$t('outlet'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('v-select',{attrs:{"options":_vm.outlets[_vm.$session.get('lang')]},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('date'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('date-range-picker',{attrs:{"startDate":_vm.start_date,"endDate":_vm.end_date,"locale-data":_vm.locale},on:{"update":_vm.updateDate}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.refresh}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('div',{staticClass:"process-container bg-secondary"},[_c('div',{staticClass:"current bg-primary",style:('width: ' + _vm.current + '%')}),_vm._v(" "),_c('div',{staticClass:"target bg-danger",style:('margin-left: ' + _vm.target + '%'),attrs:{"id":"target"}}),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.show_target,"target":"target","placement":"bottom"},on:{"update:show":function($event){_vm.show_target=$event}}},[_vm._v("\n            "+_vm._s(_vm._f("numeral")(_vm.target_sales,'0,0'))+"\n          ")])],1)])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-money"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_sale')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-shopping-basket"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque,'0,0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('total_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales/_vm.total_cheque,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('average_cheque')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('div',{staticClass:"float-right font-3xl"},[_c('i',{staticClass:"fa fa-bullhorn"})]),_vm._v(" "),_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.sos,'0,0.00')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('sos')))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.sale_by_channel_labels[_vm.$session.get('lang')],"datasets":_vm.sale_by_channel_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_by_channel')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.sale_by_type_labels[_vm.$session.get('lang')],"datasets":_vm.sale_by_type_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('sales_by_type')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('hr')]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.cheque_by_channel_labels[_vm.$session.get('lang')],"datasets":_vm.cheque_by_channel_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cheque_by_channel')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('pie',{attrs:{"labels":_vm.cheque_by_type_labels[_vm.$session.get('lang')],"datasets":_vm.cheque_by_type_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cheque_by_type')))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMix_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec520112_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMix_vue__ = __webpack_require__(739);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec520112"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec520112_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Doughnut_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Doughnut_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 737 */,
/* 738 */,
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('square-loader',{attrs:{"loading":true,"color":"#26A65B","size":"50px"}})],1):_vm._e(),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"7"}},[_c('b-form-group',{attrs:{"label":_vm.$t('outlet'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('v-select',{attrs:{"options":_vm.outlets[_vm.$session.get('lang')]},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('date'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('date-range-picker',{attrs:{"startDate":_vm.start_date,"endDate":_vm.end_date,"locale-data":_vm.locale},on:{"update":_vm.updateDate}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.refresh}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"6"}},[(_vm.best_sale_data != null)?_c('table',{staticClass:"table"},_vm._l((_vm.best_sale_data),function(item,index){return _c('tr',[_c('td',[_c('span',{staticClass:"badge",style:('background-color: ' + item.color)},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('td',{style:('font-weight: 600; color: ' + item.color)},[_vm._v(_vm._s(item.total))])])})):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('doughnut',{attrs:{"labels":_vm.best_sale_labels,"datasets":_vm.best_sale_datasets}}),_vm._v(" "),_c('div',{staticClass:"full-width text-center bg-gray-100 chart-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('top_10')))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProcessingTime_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89e4e0ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProcessingTime_vue__ = __webpack_require__(742);
function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-89e4e0ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProcessingTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89e4e0ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProcessingTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('square-loader',{attrs:{"loading":true,"color":"#26A65B","size":"50px"}})],1):_vm._e(),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('outlet'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('v-select',{attrs:{"options":_vm.outlets[_vm.$session.get('lang')]},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('date'),"label-cols":2,"label-class":"text-right","horizontal":true}},[_c('date-range-picker',{attrs:{"startDate":_vm.start_date,"endDate":_vm.end_date,"locale-data":_vm.locale},on:{"update":_vm.updateDate}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.refresh}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('search')))])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('list')))]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-hover table-sm header-pointer"},[_c('thead',[_c('tr',_vm._l((_vm.dataTable.header),function(item){return _c('th',{key:item.id,class:item.sort ? 'cursor-pointer' : '',attrs:{"scope":"col"},on:{"click":function($event){_vm.updateSort(item.name)}}},[(_vm.dataTable.sort.type == 'asc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-asc text-muted"}):_vm._e(),_vm._v(" "),(_vm.dataTable.sort.type == 'desc' && _vm.dataTable.sort.field == item.name)?_c('i',{staticClass:"fa fa-sort-amount-desc text-muted"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))])])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTable.body),function(item){return _c('tr',{key:item.id},_vm._l((_vm.dataTable.header),function(field){return _c('td',{key:field.id,attrs:{"scope":"row"}},[(field.render != null)?_c('span',{domProps:{"innerHTML":_vm._s(field.render(item[field.name]))}}):_vm._e(),_vm._v(" "),(field.render == null)?_c('span',[_vm._v("\n                      "+_vm._s(item[field.name])+"\n                    ")]):_vm._e()])}))}))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-pagination',{attrs:{"total-rows":_vm.dataTable.total,"per-page":_vm.dataTable.paginate},model:{value:(_vm.dataTable.offset),callback:function ($$v) {_vm.$set(_vm.dataTable, "offset", $$v)},expression:"dataTable.offset"}})],1),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"1"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":[10, 20, 50, 100]},model:{value:(_vm.dataTable.paginate),callback:function ($$v) {_vm.$set(_vm.dataTable, "paginate", $$v)},expression:"dataTable.paginate"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('div',{staticClass:"clearfix"},[_c('hr')])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(744);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('b-input-group',[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a83bae8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(746);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a83bae8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for is temporarily unavailable.")])]),_vm._v(" "),_c('b-input-group',[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0815e23d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0815e23d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0815e23d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('vue-progress-bar'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v(_vm._s(_vm.$t('login_title')))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('login_description')))]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error != null),expression:"error != null"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('br')]),_vm._v(" "),_c('b-form',{on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)}}},[_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-user"})])]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('username'),"aria-describedby":"username-feedback"},model:{value:(_vm.body.username),callback:function ($$v) {_vm.$set(_vm.body, "username", $$v)},expression:"body.username"}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-4"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control",attrs:{"type":"password","placeholder":_vm.$t('password'),"aria-describedby":"password-feedback"},model:{value:(_vm.body.password),callback:function ($$v) {_vm.$set(_vm.body, "password", $$v)},expression:"body.password"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('b-button',{staticClass:"px-4",attrs:{"variant":"primary"},on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t('login_title')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"7"}},[_c('b-button',{staticClass:"px-0",attrs:{"variant":"link"}},[_vm._v(_vm._s(_vm.$t('forgot_password')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"text-white bg-primary py-5 d-md-down-none",staticStyle:{"width":"44%"},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"text-center login-card-body"},[_c('div',[_c('div',{staticClass:"login-language"},[_c('change-language')],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('img',{staticClass:"login-logo",attrs:{"src":"static/img/logo.png","alt":"Central Hub"}}),_vm._v(" "),_c('p',{staticStyle:{"display":"none"}},[_vm._v("\n                  "+_vm._s(_vm.$t('slogan'))+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"login-copyright"},[_vm._v("copyright © 2018")])])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbc3780_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(777);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbc3780_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(780);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* actions */]
}));

/***/ }),
/* 779 */,
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export statelang */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(785);




var statelang = {
  lang: 'en'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], function (state, payload) {
  if (__WEBPACK_IMPORTED_MODULE_1__main__["default"] != null) {
    __WEBPACK_IMPORTED_MODULE_1__main__["default"].$i18n.locale = payload;
  }
});

var actions = {
  setLang: function setLang(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], payload);
  }
};

/***/ }),
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LANG; });
var SET_LANG = 'SET_LANG';

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_session__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_session__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_session___default.a, {
  persist: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = { en: __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json___default.a, vi: __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json___default.a };
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages,
  fallbackLocale: 'en'
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 787 */,
/* 788 */
/***/ (function(module, exports) {

module.exports = {"english":"English","vietnamese":"Vietnamese","login_title":"Login","login_description":"Sign In to your account","username":"Username","password":"Password","forgot_password":"Forgot password?","slogan":"Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.","field_required":"This is a required field","field_email":"This is a Email field","field_confirm":"This is not match","field_number":"Must be number","are.you.looking.for.something":"Can we help you to find for something?","logout":"Logout","hello":"Hello","error":"Error","success":"Success","save_successful":"Save Successful","all":"All","name":"Name","description":"Description","address":"Address","phone":"Phone","fax":"Fax","terms_of_payment":"Terms Of Payment","active":"Active","inactive":"InActive","action":"Action","search":"Search","email":"Email","avatar":"Avatar","confirm_password":"Confirm Password","store":"Store","is_active":"Active","daily_batch":"Daily Batch","tax":"Tax","home":"Home","dashboard":"Dashboard","report":"Report","system":"System","users":"Users","roles":"Roles","permissions":"Permissions","code":"Code","super.admin":"Super Admin","guest":"Guest","user":"User","role":"Role","permission":"Permission","client":"Client","profile":"Profile","edit":"Edit","save":"Save","update":"Update","create":"Create","delete":"Delete","list":"List","back":"Back","update_status":"Update Status","detail":"Detail","config":"Config","group":"Group","key":"Key","value":"Value","customizes":"Customizes","field":"Field","tag":"Tag","type":"Type","class":"Class","default":"Default","undefault":"Undefault","place_holder":"Place Holder","options":"Options","text":"Text","multiple":"Multiple","check_value":"Checked value","uncheck_value":"Unchecked value","rows":"Rows","date_range":"Date Range","outlet":"Outlet","total_sale":"Total Sales","total_cheque":"Total Bill","average_cheque":"Average Bill","sos":"SOS %","daily":"Daily","weekly":"Weekly","monthly":"Monthly","target":"Target","sales_amount":"Sales Amount","sales_trend":"Sales Trend","cheque_trend":"Bill Trend","sales_by_channel":"Sales By Channel","sales_history":"Sales History","takeaway":"Takeaway","delivery":"Delivery","eat_in":"Eat In","sales_by_type":"Sales By Type","cheque_by_channel":"Bill By Channel","cheque_by_type":"Bill By Type","date":"Date","1st":"1st","2nd":"2nd","3rd":"3rd","4th":"4th","5th":"5th","6th":"6th","7th":"7th","8th":"8th","9th":"9th","10th":"10th","11th":"11th","12th":"12th","13th":"13th","14th":"14th","15th":"15th","16th":"16th","17th":"17th","18th":"18th","19th":"19th","20th":"20th","21st":"21st","22nd":"22nd","23rd":"23rd","24th":"24th","25th":"25th","26th":"26th","27th":"27th","28th":"28th","29th":"29th","30th":"30th","31st":"31st","32nd":"32nd","33rd":"33rd","34th":"34th","35th":"35th","36th":"36th","37th":"37th","38th":"38th","39th":"39th","40th":"40th","41st":"41st","42nd":"42nd","43rd":"43rd","44th":"44th","45th":"45th","46th":"46th","47th":"47th","48th":"48th","49th":"49th","50th":"50th","51st":"51st","52nd":"52nd","january":"January","february":"February","march":"March","april":"April","may":"May","june":"June","july":"July","august":"August","september":"September","october":"October","november":"November","december":"December","online":"Online","call_center":"Call Center","offline":"Offline","aggregator":"Aggregator","offline_go_jek":"Go-Jek","grab":"Grab","account":"Account","genstore":"Genstore","uom":"Uom","uom_detail":"Uom Detail","material":"Material","material_detail":"Material Detail","supplier":"Supplier","recipe":"Recipe","recipe_detail":"Recipe Detail","recipe_detail_usage":"Recipe Detail Usage","recipe_detail_usage_unit":"Recipe Detail Usage Unit","recipe_detail_status":"Recipe Detail Status","recipe_default":"Recipe Default","master_data":"Master data","sync":"Sync","master_group":"Master Group","group_id":"Group","group_code":"Group Code","group_name":"Group Name","master_type":"Master Type","type_id":"Type","type_code":"Type Code","type_name":"Type Name","type_description":"Type Description","master_account":"Master Account","account_id":"Account id","account_code":"Account Code","account_name":"Account Name","master_genstore":"Master Genstore","genstore_code":"Genstore Code","genstore_name":"Genstore Name","genstore_description":"Genstore Description","master_uom":"Master Uom","uom_name":"Uom Name","master_uom_detail":"Master Uom Detail","from_uom_name":"From Uom","to_uom_name":"To Uom","from_uom_qty":"Qty From Uom","to_uom_qty":"Qty To Uom","conversion_rate":"Conversion Rate","is_actived":"Active","master_material":"Master Material","material_id":"Material id","material_code":"Material Code","material_name":"Material Name","net_weight":"Weight","material_uom":"Uom","recipe_rate":"Net Weight","master_material_detail":"Material Detail","material_detail_id":"Material Detail id","material_detail_code":"Material Detail Code","material_detail_name":"Material Detail Name","supplier_unit_name":"Supplier unit","supplier_uom_id":"Supplier Unit","outlet_uom_id":"Outlet Unit","outlet_uom_detail_id":"Outlet Uom","smaller_uom_id":"Smaller unit","smaller_uom_detail_id":"Smaller uom","outlet_uom_name":"Outlet unit","outlet_uom_detail_name":"Outlet uom","recipe_uom_id":"Recipe unit","recipe_uom_name":"Recipe unit","recipe_uom_detail_name":"Recipe uom","recipe_uom_detail_id":"Recipe uom","smaller_uom_name":"Smaller unit","smaller_uom_detail_name":"Smaller uom","report_uom_id":"Report unit","report_uom_name":"Report uom","fixed_unit":"Fixed unit","supplier_master":"Supplier Master","supplier_id":"Supplier Id","supplier_code":"Supplier Code","supplier_name":"Supplier Name","supplier_address":"Supplier Address","supplier_phone":"Supplier Phone","supplier_fax":"Supplier Fax","supplier_terms_of_payment":"Supplier Terms Of Payment","supplier_import_do":"Import DO Online","master_recipe":"Master Recipe","plucode":"Plucode","sku":"Sku","recipe_code":"Recipe Code","master_recipe_detail":"Master Recipe Detail","recipe_detail_name":"Recipe Detail Name","recipe_detail_code":"Recipe Detail Code","uom_detail_name":"Uom Detail Name","recipe_name":"Recipe Name","is_default":"Default","expired_in":"Expired In","usage":"Usage","price":"Price","master":"Master","short_code":"Short Code","long_name":"Long Name","current_price":"Current Price","current_qty":"Current Qty","short_name":"Short Name","uom_id":"UOM Id","r_uom_id":"R UOM Id","product_mix":"Product Mix","top_10":"TOP 10","order_processing_time":"Order time","order_number":"Order number","channel":"Channel","order_type":"Order type","order_date":"Order date","sent_to_kds":"Kds time","cooked":"Cooked time","delivery_start_time":"Delivered time","customer_recieved":"Customer received","encashment_time":"Encashment time","sos_achived":"SOS","master_material_detail_supplier":"Master Material Detail Supplier","material_detail_supplier":"Material Detail Supplier","master_material_recipe_mapping":"Master Material Recipe Mapping","source_type":"Source Type","source_code":"Source Code","destination_type":"Destination Type","destination_code":"Destination Code","supplier_names":"List Supplier","sync_data":"Sync Data","sync_master":"Sync Master","is_sync":"Sync to POS","version":"Version","sync_master_detail":"Sync Master Detail","file_name":"File Name","store_code":"Store Code","already_sync_to_pos":"Already Sync To Pos","not_sync_to_pos":"Not Sync To Pos","inventory":"Inventory"}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = {"english":"Tiếng Anh","vietnamese":"Tiếng Việt","login_title":"Đăng nhập","login_description":"Đăng nhập với tài khoản của bạn","username":"Tài khoản","password":"Mật khẩu","forgot_password":"Quên mật khẩu?","slogan":"Một con vịt xòe ra hai cái cánh, nó kêu rằng cáp cáp cáp, cạp cạp cạp. Gặp hồ nước nó bì bà bì bõm, lúc lên bờ vẫy cái cánh cho khô.","field_required":"Trường này không được bỏ trống.","field_email":"Trường này phải là Email","field_confirm":"Trường này không chính xác","field_number":"Phải là số","are.you.looking.for.something":"Chúng tôi có thể giúp bạn tìm kiếm?","logout":"Đăng xuất","hello":"Xin chào","error":"Lỗi!","success":"Thành công!","save_successful":"Lưu thành công.","all":"Tất cả","name":"Tên","description":"Mô tả","address":"Địa chỉ","active":"Kích hoạt","inactive":"Ngưng hoạt động","action":"","search":"Tìm kiếm","email":"Email","avatar":"Ảnh đại diện","confirm_password":"Xác nhận mật khẩu","store":"Cửa hàng","is_actived":"Active","home":"Trang chủ","dashboard":"Bảng điều khiển","report":"Thống kê","system":"Hệ thống","users":"Nhân viên","roles":"Chức vụ","permissions":"Chức năng","code":"Mã","super.admin":"Toàn quyền tối cao","guest":"Khách vãng lai","user":"Nhân viên","role":"Chức vụ","permission":"Quyền","client":"Thị trường","profile":"Cá nhân","save":"Thêm mới","edit":"Cập nhật","update":"Cập nhật","create":"Tạo mới","delete":"Xóa","list":"Danh sách","back":"Trở lại","update_status":"Cập nhật trạng thái","detail":"Chi tiết","config":"Cài đặt","group":"Nhóm","key":"Tên","value":"Giá trị","customizes":"Tùy chỉnh","field":"Trường","tag":"Tag","type":"Type","class":"Class","default":"Default","place_holder":"Place Holder","options":"Options","text":"Text","multiple":"Multiple","check_value":"Checked value","uncheck_value":"Unchecked value","rows":"Rows","date_range":"Thời gian","outlet":"Cửa hàng","total_sale":"Tổng doanh thu","total_cheque":"Tổng đơn hàng","average_cheque":"Trung bình đơn hàng","sos":"SOS %","daily":"Ngày","weekly":"Tuần","monthly":"Tháng","target":"Mục tiêu","sales_amount":"Tổng đơn hàng","sales_trend":"Xu hướng mua hàng","cheque_trend":"Cheque Trend","sales_by_channel":"Kênh bán hàng","sales_history":"Lịch sử bán hàng","takeaway":"Mang về","delivery":"Giao hàng","sales_by_type":"Loại bán hàng","cheque_by_channel":"Kênh bán hàng","cheque_by_type":"Loại bán hàng","date":"Ngày","1st":"Tuần 1","2nd":"Tuần 2","3rd":"Tuần 3","4th":"Tuần 4","5th":"Tuần 5","6th":"Tuần 6","7th":"Tuần 7","8th":"Tuần 8","9th":"Tuần 9","10th":"Tuần 10","11th":"Tuần 11","12th":"Tuần 12","13th":"Tuần 13","14th":"Tuần 14","15th":"Tuần 15","16th":"Tuần 16","17th":"Tuần 17","18th":"Tuần 18","19th":"Tuần 19","20th":"Tuần 20","21st":"Tuần 21","22nd":"Tuần 22","23rd":"Tuần 23","24th":"Tuần 24","25th":"Tuần 25","26th":"Tuần 26","27th":"Tuần 27","28th":"Tuần 28","29th":"Tuần 29","30th":"Tuần 30","31st":"Tuần 31","32nd":"Tuần 32","33rd":"Tuần 33","34th":"Tuần 34","35th":"Tuần 35","36th":"Tuần 36","37th":"Tuần 37","38th":"Tuần 38","39th":"Tuần 39","40th":"Tuần 40","41st":"Tuần 41","42nd":"Tuần 42","43rd":"Tuần 43","44th":"Tuần 44","45th":"Tuần 45","46th":"Tuần 46","47th":"Tuần 47","48th":"Tuần 48","49th":"Tuần 49","50th":"Tuần 50","51st":"Tuần 51","52nd":"Tuần 52","january":"Tháng 1","february":"Tháng 2","march":"Tháng 3","april":"Tháng 4","may":"Tháng 5","june":"Tháng 6","july":"Tháng 7","august":"Tháng 8","september":"Tháng 9","october":"Tháng 10","november":"Tháng 11","december":"Tháng 12","online":"Online","call_center":"Tổng đại","offline":"Cửa hàng","aggregator":"Đối tác","offline_go_jek":"Go-Jek","grab":"Grab","master_group":"Master Group","group_id":"Group ID","group_name":"Group Name","master_type":"Master Type","type_id":"Type ID","type_name":"Type Name","master_account":"Master Account","account_id":"Account","account_code":"Account Code","account_name":"Account Name","master_material":"Master Material","material_id":"Material id","material_code":"Material Code","material_name":"Material Name","master_material_detail":"Master Material Detail","material_detail_id":"Material Detail id","material_detail_code":"Material Detail Code","material_detail_name":"Material Detail Name","master_supplier":"Master Supplier","supplier_id":"Supplier id","supplier_code":"Supplier Code","supplier_name":"Supplier Name","supplier_address":"Supplier Address","master":"Master","short_code":"Short Code","long_name":"Long Name","current_price":"Current Price","current_qty":"Current Qty","short_name":"Short Name","uom_id":"UOM Id","r_uom_id":"R UOM Id","unit":"Đơn vị","unit_conversion":"Unit Conversion","first_unit":"First Unit","first_num":"First Number","second_unit":"Second Unit","second_num":"Second Number","supplier_unit":"Supplier Unit","recipe_unit":"Recipe Unit","opname_unit":"Operation Unit","bom":"Bom","bom_code":"Code","quantity":"Quantity","price":"Price","sku":"Sku","master_quantity":"Master Quantity","master_unit":"Master Unit","master_price":"Master Price","product_mix":"Product Mix","top_10":"TOP 10","order_processing_time":"Thời gian xử lý","order_number":"Order number","channel":"Channel","order_type":"Order type","order_date":"Order date","sent_to_kds":"Kds time","cooked":"Cooked time","delivery_start_time":"Delivered time","customer_recieved":"Customer received","encashment_time":"Encashment time","sos_achived":"SOS","inventory":"Inventory"}

/***/ }),
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */
/***/ (function(module, exports) {

module.exports = {"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ })
],[105]);


// WEBPACK FOOTER //
// static/js/app.020a747f9bc3d154f635.js